import { BLOG_RESTAURANTS_PART1 } from "./blog-restaurants-p1";
import { BLOG_RESTAURANTS_PART2 } from "./blog-restaurants-p2";
import { BLOG_RESTAURANTS_PART3 } from "./blog-restaurants-p3";
import { BLOG_RESTAURANTS_PART4 } from "./blog-restaurants-p4";
import { BLOG_EVENTS_PART1 } from "./blog-events-p1";
import { BLOG_EVENTS_PART2 } from "./blog-events-p2";
import { BLOG_EVENTS_PART3 } from "./blog-events-p3";
import { BLOG_EVENTS_PART4 } from "./blog-events-p4";
import { BLOG_CUISINE_PART1 } from "./blog-cuisine-p1";
import { BLOG_CUISINE_PART2 } from "./blog-cuisine-p2";
import { BLOG_CUISINE_PART3 } from "./blog-cuisine-p3";
import { BLOG_FAQ_PART1 } from "./blog-faq-p1";
import { BLOG_FAQ_PART2 } from "./blog-faq-p2";
import { BLOG_GUIDE_PART1 } from "./blog-guide-p1";
import { BLOG_GUIDE_PART2 } from "./blog-guide-p2";
import { BLOG_GUIDE_PART3 } from "./blog-guide-p3";
import { BLOG_LIFESTYLE_PART1 } from "./blog-lifestyle-p1";
import { BLOG_LIFESTYLE_PART2 } from "./blog-lifestyle-p2";
import { BLOG_BIRTHDAY_PART1 } from "./blog-birthday-p1";
import { BLOG_BIRTHDAY_PART2 } from "./blog-birthday-p2";
import { BLOG_BIRTHDAY_PART3 } from "./blog-birthday-p3";
import { BLOG_BIRTHDAY_PART4 } from "./blog-birthday-p4";
import { BLOG_BIRTHDAY_PART5 } from "./blog-birthday-p5";

export interface BlogPost {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  keywords: string;
  date: string;
  category: string;
  readTime: number;
  image: string;
  lead: string;
  sections: {
    heading: string;
    body: string;
    list?: string[];
    highlight?: string;
  }[];
  cta: { text: string; href: string };
}

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "gde-otmetit-den-rozhdeniya-v-peterburge",
    title: "Где отметить день рождения в Петербурге: топ идей с видом на город",
    metaTitle: "Где отметить день рождения в Петербурге — идеи 2026 | Паруса на крыше",
    metaDescription: "Планируете день рождения в Санкт-Петербурге? Рассказываем, где провести незабываемый праздник с видом на город, живой музыкой и скидкой 20% для именинника.",
    keywords: "где отметить день рождения Петербург, ресторан день рождения СПб, день рождения с видом на город, праздник ресторан Петербург 2026, лучшие рестораны СПб день рождения",
    date: "2026-05-15",
    category: "Особые поводы",
    readTime: 8,
    image: "/photos/view_sunset.jpg",
    lead: "День рождения в Петербурге — это всегда особая история. Город с белыми ночами, барочными фасадами и видами, от которых перехватывает дыхание, создаёт идеальный фон для праздника. Но где именно провести этот вечер — выбор непростой: хочется и атмосферы, и вкусной еды, и чтобы гости были в восторге. Мы разобрали самые популярные форматы дней рождения в Петербурге, честно сравнили варианты и рассказали, почему ресторан на крыше остаётся выбором тех, кто хочет по-настоящему запоминающегося праздника.",
    sections: [
      {
        heading: "Что делает день рождения незабываемым",
        body: "Психологи и организаторы мероприятий сходятся в одном: главное на дне рождения — не еда и не программа, а впечатление. То, что гости унесут с собой в памяти. Если попросить людей вспомнить лучший день рождения в их жизни — почти всегда окажется, что дело в месте. Особенное место меняет всё: оно создаёт настроение ещё до того, как принесут первое блюдо, оно становится общей темой для разговоров и фотографий, оно превращает обычный вечер в событие. Именно поэтому рестораны с видом, панорамные площадки и нестандартные пространства в Петербурге так востребованы для дней рождения. Люди готовы платить за впечатление — и оно окупается сторицей.",
        list: [
          "Место задаёт тон всему вечеру ещё на входе",
          "Необычный вид или интерьер — это общая тема для всех гостей",
          "Впечатление от места помнят дольше, чем вкус блюд",
          "Фотографии с события — долгосрочная память о вашем дне рождения",
        ],
      },
      {
        heading: "Ресторан на крыше — почему это работает",
        body: "Представьте: вы за столом, за окном панорама Петербурга — купола Казанского собора, крыши Центрального района, закат над Невой. Живая музыка, авторская кухня и бокал шампанского в руке. Именно такой формат сейчас в тренде — и именно за этим гости выбирают ресторан «Паруса на крыше» на 6-м этаже Olympic Plaza. Ресторан работает с 2009 года и давно стал негласным стандартом для особых поводов в Петербурге. За эти годы здесь отметили тысячи дней рождения — и каждый раз команда старается сделать вечер по-настоящему особенным. Рейтинг 5,0 на Яндексе и звание «Хорошее место 2026» — не случайность, а результат многолетней работы.",
        list: [
          "Панорамный вид 300° на исторический центр Петербурга",
          "Лучший ресторан по версии Time Out — выбор тех, кто разбирается",
          "Скидка 20% на весь счёт именинника — за 7 дней до и после ДР",
          "Торт от шеф-кондитера и персональное поздравление в подарок",
          "Работает с 2009 года — более 15 лет репутации",
        ],
        highlight: "Скидка 20% действует не только в день рождения, но и в течение 7 дней до и 7 дней после. Оплата по акции — наличными. Нужно предупредить при бронировании.",
      },
      {
        heading: "Форматы праздника: от камерного ужина до вечеринки",
        body: "В зависимости от того, как вы хотите отметить день рождения, «Паруса на крыше» предлагают несколько форматов. Для тихого ужина на двоих или троих — столик у панорамного окна с видом на закат: никакого шума, только музыка и город за стеклом. Для дружеской компании до 20 человек — отдельный зал с персональным обслуживанием, где можно расставить столы по своему усмотрению и пригласить ведущего. Для масштабной вечеринки — банкетный зал и открытая терраса на свежем воздухе, которая закрывается специально для вас: до 300 гостей, профессиональная сцена, звук, свет и вид на ночной Петербург. Каждый формат — это готовый сценарий, который команда ресторана помогает выстроить под ваши пожелания.",
      },
      {
        heading: "Как забронировать и что уточнить заранее",
        body: "Бронирование можно сделать онлайн через сайт или по телефону +7 (812) 991-10-90. При бронировании важно сообщить несколько вещей: что планируется день рождения, примерное количество гостей, желаемое время и формат (просто ужин или полноценный банкет). Это позволит менеджеру подобрать оптимальный столик или зал и заранее подготовить сюрприз. Если хотите украшение стола — лепестки роз, свечи, шарики — уточните это при бронировании: всё можно организовать за дополнительную плату или бесплатно для именинника. Для банкета на 30+ человек рекомендуем бронировать за 2–3 недели, особенно на выходные.",
        highlight: "Чтобы получить скидку 20%, обязательно сообщите о дне рождения при бронировании — иначе акция может не примениться.",
      },
      {
        heading: "Меню и кухня: что заказывать",
        body: "Авторская кухня «Парусов» — отдельная тема. Шеф-повар работает с локальными продуктами Северо-Запада: балтийской рыбой, карельскими грибами, новгородскими ягодами. Гости особенно выделяют уху из лосося с гребешком, тартар из говядины с трюфельным маслом, ризотто с белыми грибами и фирменный торт «Птичье молоко» с видом на город. Для банкета удобно выбрать банкетное меню — менеджер предоставляет несколько вариантов на разные бюджеты. В них уже включены закуски, горячее, десерт и безалкогольные напитки. Алкоголь — отдельно, карта вин достаточно разнообразная: от петербургских крафтовых позиций до классических итальянских и грузинских вин.",
        list: [
          "Уха из лосося с гребешком — фирменное блюдо",
          "Тартар из говядины с трюфельным маслом",
          "Ризотто с белыми грибами и пармезаном",
          "Торт «Птичье молоко» — классика в авторском исполнении",
          "Банкетное меню от 2 500 ₽/чел — уточняйте актуальные варианты",
        ],
      },
      {
        heading: "Другие идеи для дня рождения в Петербурге",
        body: "Если вы ещё выбираете или хотите сравнить — вот несколько альтернатив, которые популярны у петербуржцев. Ужин на теплоходе по Неве — красивый формат, особенно в белые ночи, но нет постоянного места и часто ограниченное меню. Джаз-клуб — прекрасная атмосфера, живая музыка, но практически никакого вида на город. Авторский ресторан на Рубинштейна или Петроградке — хорошая кухня, но без особого вида и нередко шумно. Частная терраса в лофте — модно, но как правило нет собственной кухни, нужен кейтеринг. «Паруса на крыше» выигрывают тем, что объединяют всё в одном: вид, кухню, музыку, сервис и скидку именинника.",
        list: [
          "Ужин на теплоходе — красиво, но нет постоянного места и комфорта",
          "Джаз-клуб — живая музыка, но без панорамы",
          "Авторский ресторан на Рубинштейна — кухня хорошая, вида нет",
          "Лофт с кейтерингом — модно, но нет готовой кухни и сервиса",
          "Паруса на крыше — панорама, музыка, скидка ДР, всё в одном",
        ],
      },
      {
        heading: "Лучшее время года для дня рождения на крыше",
        body: "Многие думают, что ресторан на крыше — это только летнее удовольствие. На деле «Паруса» работают круглый год, и у каждого сезона своя магия. Летом — белые ночи, открытая терраса, закаты в 22:30 прямо за вашим столиком. Осенью — золотые крыши, дождь за панорамными окнами, ощущение уюта и камерности. Зимой — заснеженные купола, рождественские огни над городом, глинтвейн и горячие блюда. Весной — первое тепло и ощущение, что город просыпается у вас на глазах. Единственный нюанс: летом и в праздничные периоды (Новый год, 8 Марта, 14 февраля) нужно бронировать заранее — иногда за 2–4 недели.",
        highlight: "Лучшее время для заката с крыши летом — 20:30–21:30. Зимой вечерний вид особенно красив примерно с 17:00.",
      },
      {
        heading: "Практические советы именинника",
        body: "Несколько лайфхаков для тех, кто планирует день рождения в «Парусах». Во-первых, заранее уточните программу живой музыки — расписание есть в разделе «Афиша»: если в ваш вечер выступает хороший джазовый ансамбль, это добавит атмосферы. Во-вторых, приходите немного раньше гостей — это позволит проверить украшение стола и спокойно встретить каждого. В-третьих, попросите официанта сделать общее фото компании: профессиональный кадр на фоне панорамы Петербурга — это лучший сувенир. И наконец — не забудьте предупредить при бронировании, что у вас день рождения, чтобы получить скидку 20% и персональное поздравление от команды.",
      },
    ],
    cta: { text: "Забронировать стол на день рождения", href: "/den-rozhdeniya" },
  },

  {
    slug: "restorany-s-vidom-na-peterburg",
    title: "Рестораны с видом на Петербург: где поесть с панорамой города",
    metaTitle: "Рестораны с видом на Петербург — лучшие места 2026 | Паруса на крыше",
    metaDescription: "Обзор ресторанов Санкт-Петербурга с панорамным видом на город. Где поесть с видом на крыши, Неву и купола — выбор гурмана и туриста в 2026 году.",
    keywords: "рестораны с видом на Петербург, панорамный ресторан СПб, ресторан на крыше Петербург, ресторан вид на город СПб, лучшие рестораны Петербурга с видом",
    date: "2026-04-20",
    category: "Гид по городу",
    readTime: 9,
    image: "/photos/view_clouds.jpg",
    lead: "Петербург прекрасен с любой точки — но особенно с высоты. Рестораны с видом на город собирают очереди из туристов и местных жителей, которые хотят совместить хороший ужин с незабываемой панорамой. Купола, шпили, крыши с петушками, Нева — в этом городе каждый вид рассказывает историю. В этом гиде мы честно разобрали, что сейчас предлагает Петербург в сегменте «поесть с видом» и на что обращать внимание при выборе.",
    sections: [
      {
        heading: "Почему важно «где», а не только «что»",
        body: "Ресторанный опыт — это не только вкус блюда. Это атмосфера, вид за окном, звук живой музыки и ощущение места. Нейробиологи подтверждают: в приятной обстановке еда воспринимается вкуснее — это называется «кросс-модальное взаимодействие». Петербург — один из немногих городов мира, где вид из ресторана может конкурировать с самой кухней. Купола Казанского собора на уровне взгляда, Невский проспект лентой уходящий вдаль, золото куполов Исаакия на закате — это декорации, которые не создашь никаким дизайнером. Именно поэтому рестораны с видом в Петербурге стоят особняком: они продают не просто ужин, а переживание.",
      },
      {
        heading: "Форматы «с видом»: что бывает в Петербурге",
        body: "Прежде чем идти по конкретным адресам, важно понять: «ресторан с видом» в Петербурге — это несколько совершенно разных форматов. Первый — рестораны на крышах зданий: самый зрелищный вариант, но качество сильно варьируется. Второй — рестораны в верхних этажах отелей и бизнес-центров: как правило, хорошее обслуживание, но вид ограничен одной стороной. Третий — рестораны на набережной с видом на Неву: красиво, но «высоты» нет, и в плохую погоду вид теряется. Четвёртый — летние веранды с видом на исторические фасады: сезонно и непостоянно. Лучшее, что предлагает город — это полноценный ресторан на крыше с круглогодичной работой, нормальной кухней и панорамой в несколько сторон одновременно.",
        list: [
          "Рестораны на крышах — самый зрелищный формат, качество разное",
          "Верхние этажи отелей — стабильный сервис, вид в одну сторону",
          "Набережные — красиво, но нет высоты и зависит от погоды",
          "Летние веранды — сезонно, нет стабильности",
        ],
      },
      {
        heading: "«Паруса на крыше»: что отличает от других",
        body: "Ресторан «Паруса на крыше» на ул. Марата, 5 (6-й этаж Olympic Plaza) работает с 2009 года — это принципиально важно. За 15 лет сложилась и отточена всё: кухня, сервис, управление бронированием, работа в разные сезоны. Панорама действительно 300°: одновременно видны купол Казанского собора, шпили Адмиралтейства, крыши Центрального района и, в ясную погоду, Исаакиевский собор. Это не «вид на двор с деревьями» — это вид, ради которого люди едут в Петербург. При этом ресторан работает круглый год: летом — открытая терраса, зимой — тёплый зал с панорамными окнами от пола до потолка.",
        list: [
          "Работает с 2009 года — репутация выстраивалась 15 лет",
          "Панорама 300°: Казанский, Адмиралтейство, Исаакий",
          "Круглогодичная работа — не сезонный pop-up",
          "Открытая терраса летом + тёплый зал зимой",
          "Рейтинг 5,0 на Яндексе · 2 606 отзывов",
          "«Хорошее место 2026» и лучший ресторан по версии Time Out",
        ],
        highlight: "В отличие от большинства «крышных» заведений Петербурга, «Паруса» — это настоящий ресторан с авторской кухней, а не бар с чипсами и видом.",
      },
      {
        heading: "Чего ожидать от кухни",
        body: "Вид — это важно, но голодным с крыши не уйдёшь. В «Парусах» кухня — не декорация к виду, а полноценная авторская концепция. Шеф работает с продуктами Северо-Запада: карельская форель и лосось, балтийские устрицы в сезон, грибы из ленинградских лесов, ягоды, травы. В меню — европейская база с российским характером: уха с гребешком, тартары, ризотто, стейки, сезонные блюда. Летом особенно популярна открытая терраса с облегчённым меню — сырные тарелки, свежая рыба на гриле, легкие десерты. Средний чек на двоих с бокалом вина — 4 000–7 000 ₽, что для такого уровня кухни и вида вполне адекватно.",
        list: [
          "Авторская кухня на локальных продуктах Северо-Запада",
          "Уха из лосося с гребешком — фирменное блюдо",
          "Тартар из говядины, ризотто с грибами, сезонная рыба",
          "Обширная карта вин: грузинские, итальянские, российские",
          "Средний чек на двоих: 4 000–7 000 ₽",
        ],
      },
      {
        heading: "Когда ехать: сезоны и их особенности",
        body: "У каждого сезона в «Парусах» своя атмосфера. Летом (май–сентябрь) — это открытая терраса, белые ночи и закаты после 22:00. Это самое популярное время, поэтому бронировать нужно за 3–7 дней на выходные. Осенью (октябрь–ноябрь) — золотые крыши, тихие будние вечера, туман над городом. Самое умиротворённое время — столики свободнее, атмосфера более камерная. Зимой (декабрь–февраль) — рождественские огни, снег на куполах, тёплый зал с горячими блюдами. В новогодний период и на 8 Марта — аншлаг, бронировать за 2–4 недели. Весной (март–апрель) — город просыпается, первое солнце после долгой зимы, открытие терасного сезона.",
        highlight: "Лучшее время для заката: летом — 20:30–21:30, осенью — 16:30–17:30. Попросите столик у западного окна или на террасе.",
      },
      {
        heading: "Как добраться и где припарковаться",
        body: "Ресторан находится по адресу ул. Марата, 5, вход в Olympic Plaza — 6-й этаж. Удобнее всего добираться на метро: станции «Маяковская» и «Площадь Восстания» в пяти минутах пешком. На машине — в центре Петербурга с парковкой непросто, но рядом есть платная парковка на ул. Марата и несколько стихийных мест по соседним переулкам. Такси или каршеринг — самый удобный вариант, особенно если планируете вечер с вином. Ресторан хорошо видно с улицы: вывеска на фасаде, а сам зал на 6-м этаже отлично просматривается снаружи.",
      },
      {
        heading: "Советы для лучшего опыта",
        body: "Чтобы получить максимум от визита в панорамный ресторан Петербурга, несколько практических советов. Бронируйте столик у окна заранее — это самые востребованные места и они заканчиваются первыми. Уточняйте программу живой музыки: расписание публикуется в разделе «Афиша» на сайте. Если едете специально ради заката — уточните у хостес, с какой стороны закатное солнце в конкретный день. Приходите за 15–20 минут до бронирования — это даст время осмотреться, сделать фото и не торопиться с первым бокалом. И обязательно посетите террасу летом, даже если у вас столик в зале: вид с открытого воздуха — совсем другое ощущение.",
        list: [
          "Бронируйте столик у окна — уточните при бронировании",
          "Проверьте расписание живой музыки на сайте",
          "Приходите за 15–20 минут до бронирования",
          "Летом обязательно выйдите на открытую террасу",
          "Фото на фоне панорамы — лучше всего получаются в сумерках",
        ],
      },
    ],
    cta: { text: "Забронировать столик с видом", href: "/contacts" },
  },

  {
    slug: "romanticheskoe-svidanie-v-spb",
    title: "Романтическое свидание в Петербурге: куда сходить в 2026 году",
    metaTitle: "Романтическое свидание в Петербурге — куда пойти 2026 | Паруса на крыше",
    metaDescription: "Планируете романтический вечер в Санкт-Петербурге? Лучшие идеи для свидания с видом на город, живой музыкой и авторской кухней. Ресторан на крыше ул. Марата, 5.",
    keywords: "романтическое свидание Петербург, куда сходить на свидание СПб, романтический ужин ресторан Петербург, свидание с видом на город СПб, куда пойти вечером СПб",
    date: "2026-05-01",
    category: "Особые поводы",
    readTime: 8,
    image: "/photos/view_sunset.jpg",
    lead: "Петербург создан для романтики — белые ночи, разводные мосты, отражения фонарей в тёмной воде каналов, запах цветущих лип в июне. Этот город умеет создавать настроение без усилий. Но найти место, где романтика атмосферы соединится с хорошей едой, видом на город и тем самым ощущением «всё правильно» — задача не такая простая. В этом гиде мы разобрали несколько форматов романтического вечера в Петербурге и честно рассказали, почему ужин на крыше остаётся золотым стандартом для тех, кто хочет произвести впечатление.",
    sections: [
      {
        heading: "Почему место важнее программы",
        body: "Когда люди вспоминают лучшие свидания в своей жизни, они редко говорят о конкретном блюде или о том, что именно звучало в плейлисте. Они говорят о месте. О том, как выглядел закат. О том, что за окном был весь город. О запахе морского ветра или тёплого дерева. Место — это эмоциональный якорь, который фиксирует момент в памяти. Именно поэтому для романтического свидания выбор пространства важнее, чем выбор блюд или вина. Хорошее место само создаёт нужное настроение — вам остаётся только наслаждаться.",
      },
      {
        heading: "Идеи для романтического вечера в Петербурге",
        body: "Петербург предлагает несколько принципиально разных форматов романтического вечера. Каждый хорош по-своему — вопрос в приоритетах. Разводные мосты — бесплатно, красиво, но холодно, долго стоять на улице и нет еды. Прогулка на теплоходе — атмосфера есть, но нет постоянного места, часто шумно и качает. Концерт в филармонии или капелле — культурно и запоминающе, но требует специфического настроения. Ужин в ресторане с видом на Неву — хорошо, но «высоты» нет. Ужин на крыше с видом на весь центр города — пока что лучший ответ на вопрос «куда пойти на романтическое свидание в СПб».",
        list: [
          "Разводные мосты — красиво, но холодно и нет комфорта",
          "Теплоход — атмосфера есть, качает, нет постоянного места",
          "Филармония — культурно, требует специального настроения",
          "Ресторан на Неве — хорошо, но без высоты и панорамы",
          "Ужин на крыше — лучший баланс атмосферы, комфорта и впечатления",
        ],
      },
      {
        heading: "Ужин в «Парусах на крыше»: что ждёт вас",
        body: "«Паруса на крыше» — это то место, куда приходят, чтобы произвести впечатление. И это работает. Ресторан на 6-м этаже Olympic Plaza открывает панораму на 300°: одновременно видны купол Казанского собора, Невский проспект, крыши Центрального района и — в ясную погоду — Исаакиевский собор. Летом терраса открыта: сидишь на свежем воздухе с бокалом вина, внизу гудит город, а над головой — небо в белых ночах. Зимой — тёплый зал с огромными панорамными окнами, живая музыка и ощущение, что весь Петербург накрыт для вас. Сервис ненавязчивый, но внимательный: официанты умеют читать настроение и не мешают разговору.",
        highlight: "Попросите столик у западного окна — оттуда закат виден прямо перед вами. Уточните при бронировании.",
      },
      {
        heading: "Как организовать особенный вечер",
        body: "Стандартный ужин можно превратить в настоящий сюрприз — команда ресторана в этом охотно помогает. При бронировании можно заказать украшение стола: лепестки роз, свечи, именная карточка с надписью. Если хотите сюрприз для партнёра — договоритесь заранее: можно организовать подачу цветов, шампанского при входе или персонального поздравления от шеф-повара. Некоторые гости заказывают небольшой торт с надписью или дарят подарочный сертификат ресторана прямо за столиком. Всё это создаёт нарратив вечера, который запоминается надолго. Главное — предупредить заранее, хотя бы за день.",
        list: [
          "Украшение стола — лепестки роз, свечи, именная карточка",
          "Шампанское при входе — для начала вечера с правильного тона",
          "Торт с надписью — для особых дат и признаний",
          "Цветы — можно принести с собой или заказать через ресторан",
          "Подарочный сертификат — если хотите подарить «Паруса» как подарок",
        ],
      },
      {
        heading: "Что заказать: еда и напитки для романтического ужина",
        body: "Для романтического ужина важно выбирать блюда, которые удобно есть и которые не отвлекают на себя всё внимание. Хорошее начало — закуски: карпаччо, сырная тарелка, устрицы в сезон. Из горячего — рыба или мясо на двоих, которые можно разделить. Из десертов — что-то лёгкое: шоколадный фондан, птичье молоко, сорбет. По напиткам: сомелье «Парусов» хорошо подберёт бутылку вина под ваш заказ — не стесняйтесь спросить рекомендацию, указав бюджет. Если один из вас не пьёт — в карте есть хорошие безалкогольные коктейли и лимонады ручной работы.",
      },
      {
        heading: "Лучшее время для романтического ужина",
        body: "Летом (май–сентябрь) бронируйте на 20:30 — закат будет прямо за окном, а белые ночи создают ни с чем не сравнимое освещение, при котором все выглядят красиво. В белые ночи ресторан работает до 01:00 в пятницу и субботу — ночной Петербург с высоты это отдельный, почти мистический вид. Осенью и зимой лучшее время — с 17:00 до 19:00: вечерние огни города загораются постепенно, и наблюдать этот процесс особенно красиво. В праздничные дни (14 февраля, 8 Марта, Новый год) бронируйте за 2–3 недели — эти даты заполняются быстро.",
        highlight: "14 февраля и 8 Марта — самые популярные даты. Бронируйте минимум за 2 недели, а лучше за месяц.",
      },
      {
        heading: "Первое свидание или годовщина: в чём разница",
        body: "«Паруса на крыше» одинаково хорошо работают и для первого свидания, и для десятой годовщины — но акценты разные. Для первого свидания ключевое преимущество ресторана — тема для разговора. Вид на город, история места, кухня — это готовые темы, которые снимают напряжение первой встречи. Для годовщины или особой даты — ресторан позволяет устроить сюрприз и создать ощущение события. В обоих случаях работает одно правило: чем лучше место, тем меньше нужно «придумывать» — атмосфера делает всё за вас.",
      },
      {
        heading: "Продолжение вечера: что делать после ужина",
        body: "После ужина в «Парусах» центр Петербурга — в нескольких минутах ходьбы. Если погода позволяет — прогулка по Невскому, вдоль каналов Коломны или к Казанскому собору. Летом можно дождаться разводки мостов: Дворцовый разводят в 01:10, Литейный в 01:40 — и это совсем рядом. Если хочется продолжить вечер в тишине — набережная Мойки или Фонтанки в ночное время практически пустая и очень красивая. В любом случае, после хорошего ужина на крыше настроение будет именно таким, что куда бы вы ни пошли — всё получится.",
      },
    ],
    cta: { text: "Забронировать романтический ужин", href: "/romanticheskiy-uzhin" },
  },

  {
    slug: "korporativ-v-peterburge-gde-provesti",
    title: "Корпоратив в Петербурге: где провести мероприятие для команды",
    metaTitle: "Корпоратив в Петербурге — лучшие площадки 2026 | Паруса на крыше",
    metaDescription: "Ищете место для корпоратива в Санкт-Петербурге? Обзор площадок: банкетные залы, рестораны, необычные форматы. Аренда зала на крыше до 300 гостей.",
    keywords: "корпоратив Петербург где провести, площадки для корпоратива СПб, аренда зала корпоратив Петербург, корпоратив ресторан СПб, новогодний корпоратив Петербург 2026",
    date: "2026-04-05",
    category: "Бизнес",
    readTime: 9,
    image: "/photos/view_clouds.jpg",
    lead: "Корпоратив — это не просто ужин с коллегами. Это инвестиция в командный дух, которая либо работает, либо нет. Правильно выбранная площадка создаёт атмосферу, в которой люди расслабляются, находят общий язык и чувствуют себя частью чего-то большего. Неправильная — превращает вечер в формальность, которую все ждут не дождутся окончания. В этом гиде мы подробно разобрали, как выбирать площадку для корпоратива в Петербурге, какие форматы бывают и почему нестандартный подход работает лучше привычного банкета в отеле.",
    sections: [
      {
        heading: "Зачем компании проводят корпоративы: цели и задачи",
        body: "Прежде чем искать место, важно понять: зачем вообще нужен корпоратив? Ответ определит формат. Если цель — сплочение новой команды, нужна площадка с возможностью интерактива: мастер-классы, квизы, общая активность. Если цель — поблагодарить сотрудников за год, нужен комфорт: хорошая еда, живая музыка, открытый бар. Если цель — презентация компании для партнёров, важны статус места и уровень сервиса. «Паруса на крыше» закрывают все три задачи: ресторан достаточно неформален для сплочения, достаточно хорош для благодарности и достаточно престижен для деловых встреч. Панорама 300° — это ещё и разговорный стартер: когда гости видят вид, первые 10 минут вечера общение завязывается само собой.",
        list: [
          "Сплочение команды — нужна интерактивность и неформальность",
          "Благодарность сотрудникам — важен комфорт и уровень кухни",
          "Деловая встреча с партнёрами — нужен статус и сервис",
          "Презентация компании — важен визуальный эффект и впечатление",
        ],
      },
      {
        heading: "На что обращать внимание при выборе площадки",
        body: "При выборе места для корпоратива в Петербурге есть несколько ключевых параметров. Вместимость — первое и очевидное: площадка должна комфортно вмещать вашу команду. Правило: не тесно и не пусто. На 30 человек в зале на 200 — чувствуется пустота и формальность. Транспортная доступность — важно, чтобы все добрались без трудностей: центр города или рядом с метро. Техническое оснащение — если планируется программа: сцена, проектор, микрофоны, профессиональный звук. Кейтеринг и кухня — уровень блюд напрямую влияет на общее впечатление: люди это помнят. Отдельный зал или открытое пространство — для корпоратива лучше приватность, без посторонних гостей.",
        list: [
          "Вместимость — не тесно и не пусто, оптимальный зал под размер команды",
          "Транспорт — центр города или рядом с метро",
          "Техника — сцена, проектор, микрофоны, профессиональный звук",
          "Кухня — уровень блюд помнят долго",
          "Приватность — отдельный зал без посторонних",
          "Парковка — особенно важно если команда приезжает на машинах",
        ],
      },
      {
        heading: "Форматы корпоратива в Петербурге",
        body: "Классический вариант — банкетный зал в отеле или бизнес-центре. Плюсы: предсказуемость, опытный персонал, стандартный сервис. Минусы: дорого за то, что не запоминается, нет атмосферы, выглядит формально. Второй популярный формат — лофт или арт-пространство. Плюсы: современно, необычно, хороший фон для фото. Минусы: часто нет собственной кухни, нужен кейтеринг, акустика бывает плохой. Третий формат — ресторан с закрытием зала. Здесь уже есть готовая кухня, сервис, атмосфера — это и есть оптимальный вариант для большинства компаний. И четвёртый — необычные форматы: теплоход, крыша, загородная резиденция. Они создают максимальный «вау»-эффект, но требуют более тщательной организации.",
        highlight: "Рестораны с видом на Петербург для корпоратива — это золотая середина: готовая кухня + сервис + атмосфера + тема для разговора.",
      },
      {
        heading: "Корпоратив на крыше: что это даёт",
        body: "«Паруса на крыше» — один из немногих ресторанов Петербурга, где можно провести корпоратив любого масштаба с по-настоящему впечатляющим видом. Профессиональная сцена, мощная звуковая система, несколько зон: основной зал, VIP-зал, открытая терраса — можно скомбинировать под любой сценарий. Для новогоднего корпоратива — ёлка на фоне ночного Петербурга, фейерверки за окнами. Для летнего — терраса с видом и живая музыка под открытым небом. Для деловой встречи с партнёрами — статус места говорит сам за себя. Менеджер по мероприятиям поможет выстроить программу: ведущий, артисты, тематическое оформление, корпоративная символика.",
        list: [
          "До 300 гостей в разных форматах",
          "Профессиональная сцена, звук и свет",
          "Несколько зон: основной зал, VIP, открытая терраса",
          "Панорама 300° на Петербург — лучший корпоративный фон",
          "Организация под ключ: ведущий, артисты, декор",
          "Банкетное меню на разные бюджеты",
        ],
      },
      {
        heading: "Программа и развлечения: что можно добавить",
        body: "Хорошая площадка — только половина успеха. Программа делает корпоратив живым. В «Парусах» есть несколько форматов, которые хорошо работают именно здесь. Живая музыка — джазовый квартет или кавер-группа отлично вписываются в атмосферу крыши. Викторина или квиз на корпоративную тему — командный конкурс, который заставляет людей перемешаться и познакомиться. Мастер-класс от сомелье или шеф-повара — интерактивно, запоминающе, хорошо работает для небольших команд. Фотозона с видом на Петербург — гарантированный контент для соцсетей. Если нужна полная организация под ключ — менеджер ресторана возьмёт координацию на себя и предложит проверенных подрядчиков.",
        list: [
          "Живая музыка — джаз, кавер-группа, выбор зависит от формата",
          "Корпоративный квиз — сплочение через игру",
          "Мастер-класс сомелье — неформально и запоминающе",
          "Фотозона с видом на Петербург — контент для соцсетей",
          "Тематическое оформление зала — под стиль компании или праздника",
        ],
      },
      {
        heading: "Новогодний корпоратив в Петербурге: планируем заранее",
        body: "Новый год — самый нагруженный сезон для корпоративных мероприятий в Петербурге. Хорошие площадки заполняются уже в сентябре–октябре. «Паруса на крыше» в декабре — это ёлки и гирлянды в зале, снег на крышах города за окнами и ощущение настоящего праздника. Для новогодних корпоративов ресторан предлагает специальные банкетные пакеты: фиксированное меню, развлекательная программа, украшение зала и, по желанию, ведущий. Рекомендуем бронировать с сентября: популярные даты (14–15, 21–22, 26–27 декабря) разбирают первыми.",
        highlight: "Для новогоднего корпоратива на декабрь — бронируйте в сентябре–октябре. Лучшие даты уходят за 2–3 месяца.",
      },
      {
        heading: "Бюджет и что в него входит",
        body: "Вопрос бюджета на корпоратив — один из ключевых при выборе площадки. В «Парусах на крыше» ценообразование прозрачное: есть аренда зала (зависит от количества гостей и дня недели) и банкетное меню на выбор. Стандартное банкетное меню начинается от 3 000–4 000 ₽ на человека и включает закуски, горячее, десерт и безалкогольные напитки. Алкоголь — отдельно, или можно оговорить пакет с открытым баром на определённое время. Дополнительно: звуковое оборудование, декор зала, услуги ведущего и артистов — всё по согласованию. Для точного расчёта под вашу команду — оставьте заявку, менеджер предоставит детальное предложение в течение часа.",
      },
      {
        heading: "Планирование: временные рамки и чек-лист",
        body: "Для корпоратива на 50+ человек рекомендуем начинать планирование за 2–3 месяца. Для небольших команд (до 20 человек) — за 2–4 недели достаточно. Ключевые этапы: определить дату и примерное число гостей → выбрать и забронировать площадку → согласовать меню и программу → уведомить команду → подтвердить детали за неделю до мероприятия. Менеджер «Парусов» сопровождает вас на каждом этапе — это снимает большую часть организационной нагрузки с вас.",
        list: [
          "За 2–3 месяца: определить дату и число гостей, забронировать зал",
          "За 4–6 недель: согласовать меню и программу, уведомить команду",
          "За 2 недели: подтвердить декор и оборудование",
          "За 3–5 дней: финальный звонок менеджеру, уточнение деталей",
          "В день мероприятия: приехать за 30 минут до гостей",
        ],
      },
    ],
    cta: { text: "Запросить расчёт корпоратива", href: "/korporativ" },
  },
  {
    slug: "biznes-lanch-restoran-na-kryshe-peterburg",
    title: "Бизнес-ланч на крыше Петербурга: обед с видом на город от 590 ₽",
    metaTitle: "Бизнес-ланч на крыше Петербурга от 590 ₽ | Паруса на крыше — Пн–Пт 12:00–16:00",
    metaDescription: "Бизнес-ланч в ресторане Паруса на крыше: 3 блюда от 590 ₽, панорамный вид на Петербург, центр города. Пн–Пт 12:00–16:00, ул. Марата 5. Отличная альтернатива офисным обедам.",
    keywords: "бизнес-ланч Петербург, бизнес-ланч ресторан на крыше СПб, обед с видом на город Петербург, бизнес-ланч центр Петербурга, недорогой обед Невский проспект, бизнес-ланч Паруса на крыше",
    date: "2026-06-09",
    category: "Кухня и меню",
    readTime: 5,
    image: "/photos/dishes/caesar_shrimp.webp",
    lead: "Что если рабочий обед превратить в маленькое событие? Бизнес-ланч в «Парусах на крыше» — это три полноценных блюда от 590 ₽ с видом на исторический центр Петербурга. Пять минут пешком от Невского, и вы за столом над городом. Разбираемся, почему всё больше петербуржцев выбирают обед на крыше вместо стандартной бизнес-столовой.",
    sections: [
      {
        heading: "Что входит в бизнес-ланч",
        body: "Меню бизнес-ланча в «Парусах на крыше» меняется регулярно, но структура остаётся постоянной: суп, основное блюдо и десерт или напиток. Это полноценный обед, а не упрощённая «ланч-версия» — повара готовят из тех же продуктов, что и для основного меню. Блюда меняются несколько раз в неделю, так что постоянные гости всегда находят что-то новое.",
        list: [
          "Три блюда — суп, горячее, десерт или напиток",
          "Авторская кухня по ценам бизнес-ланча — от 590 ₽",
          "Меню обновляется несколько раз в неделю",
          "Порции полноценные — не «ланч-формат»",
        ],
        highlight: "Бизнес-ланч доступен понедельник–пятница с 12:00 до 16:00. Стоимость — от 590 ₽ за полный комплект.",
      },
      {
        heading: "Вид на Петербург во время обеда",
        body: "Главное отличие обеда в «Парусах» — то, что происходит за окном. Ресторан расположен на 6-м этаже Olympic Plaza на улице Марата, 5. С панорамных окон открывается вид на крыши исторического центра: купола Троицкой церкви, силуэт Исаакиевского собора, бесконечная черепица старого Петербурга. В хорошую погоду работает открытая терраса — и тогда обед буквально происходит над городом. После такого перерыва возвращаться в офис заметно легче.",
      },
      {
        heading: "Удобное расположение: 5 минут от Невского",
        body: "Ресторан находится в 5 минутах пешком от станции метро «Владимирская» и в 10 минутах от «Маяковской». Улица Марата — тихая улица в самом центре, без туристической суеты Невского проспекта. Рядом — деловые кварталы Центрального и Адмиралтейского районов. Это делает «Паруса на крыше» удобным вариантом для командных обедов: легко добраться из большинства офисов центра.",
        list: [
          "Ул. Марата 5, 6 этаж Olympic Plaza",
          "5 мин пешком от м. Владимирская",
          "10 мин от м. Маяковская",
          "Есть парковка рядом с домом",
        ],
      },
      {
        heading: "Командный обед: почему это работает",
        body: "Бизнес-ланч на крыше — это не только про еду. Смена обстановки во время рабочего дня доказанно повышает продуктивность: короткий отрыв от экрана, разговор в неформальной обстановке, виды, которые «перезагружают» восприятие. Многие петербургские команды сделали обед в «Парусах» регулярной традицией — это удобно организационно (один звонок или бронь онлайн) и всегда оставляет хорошее впечатление на новых коллег или партнёров.",
        highlight: "Для группы от 6 человек рекомендуем бронировать стол заранее — в обеденное время ресторан загружен.",
      },
      {
        heading: "Сравнение с другими форматами обеда",
        body: "Кафе у офиса быстрее, но уступает по качеству еды и атмосфере. Доставка удобна, но лишает смены обстановки, которая нужна мозгу. Дорогой ресторан на Невском не вписывается в ежедневный бюджет. «Паруса на крыше» занимают нишу между: цена бизнес-ланча сопоставима с хорошим кафе, а впечатление — как от ресторана с историей и репутацией. Рейтинг 5,0 на Яндексе и 2 606 отзывов говорят сами за себя — сюда возвращаются.",
        list: [
          "Дешевле ресторанов на Невском при том же уровне кухни",
          "Лучше офисной доставки — смена обстановки входит в стоимость",
          "Быстро: средний обед занимает 45–60 минут",
          "Рейтинг 5,0 на Яндексе · Хорошее место 2026",
        ],
      },
    ],
    cta: { text: "Забронировать стол на обед", href: "/menu" },
  },

  // ─── ВОЛНА 1 (март 2026) ────────────────────────────────────────────────────
  {
    slug: "romanticheskiy-uzhin-na-kryshe-spb",
    title: "Романтический ужин на крыше в Санкт-Петербурге",
    metaTitle: "Романтический ужин на крыше СПб — Паруса на крыше",
    metaDescription: "Романтический ужин с панорамным видом на Петербург: столик у окна, свечи, закат и авторская кухня. Забронируйте особенный вечер в «Паруса на крыше» — +7 (812) 991-10-90.",
    keywords: "романтический ужин на крыше спб, ужин для двоих петербург, романтика на высоте, ужин с видом на город спб",
    date: "2026-03-10",
    category: "Романтика",
    readTime: 7,
    image: "/photos/view_sunset.webp",
    lead: "Романтический ужин на крыше в Петербурге — это столик с панорамным видом на город, закат над крышами и атмосфера высоты. В «Паруса на крыше» можно забронировать место у панорамного окна или на открытой террасе, заказать ужин при свечах и сюрприз для второго человека.",
    sections: [
      {
        heading: "Почему ужин на крыше — это особенный вечер",
        body: "Вид сверху меняет восприятие города: крыши Петербурга, купола Исаакиевского собора, линия горизонта на закате создают декорацию, которую не получить за обычным столиком. «Паруса на крыше» расположены на 6-м этаже Olympic Plaza на улице Марата, 5 — панорама является частью ужина, а не просто фоном. Для свидания, годовщины или предложения руки и сердца такой формат работает безотказно.",
        list: [
          "Панорама 300° на исторический центр Петербурга",
          "Ужин при свечах по запросу — свечи, цветы, сюрприз",
          "Открытая терраса в тёплый сезон — вид без стекла",
          "Живая музыка по пятницам и субботам",
        ],
      },
      {
        heading: "Лучшее время: закат и белые ночи",
        body: "Самый эффектный романтический ужин — за час до заката: небо меняет цвет, город подсвечивается, появляется тот самый свет для фотографий. Летом добавляются белые ночи — сумерки тянутся до глубокой ночи, создавая неповторимую атмосферу. Бронируйте столик у окна или на террасе заранее именно на закатное время — эти места разбирают первыми.",
        highlight: "В июне и июле закат в Петербурге длится до 23:00. Столик на закатное время бронируйте за 3–5 дней.",
      },
      {
        heading: "Что можно организовать для двоих",
        body: "Команда ресторана помогает сделать вечер особенным: украшение стола лепестками роз, свечи и именное меню — по запросу при бронировании. Для предложения руки и сердца можно согласовать сценарий с менеджером: момент подачи кольца, музыкальное сопровождение, фотограф. Для годовщины подготовят торт с надписью и бокал шампанского в подарок.",
        list: [
          "Столик у панорамного окна или на открытой террасе",
          "Ужин при свечах и именная карточка",
          "Букет, десерт с надписью, поздравление от шефа",
          "Помощь со сценарием предложения руки и сердца",
        ],
      },
      {
        heading: "Меню для романтического ужина",
        body: "Шеф-повар предлагает блюда, которые удобно разделить на двоих: лёгкие закуски из морепродуктов, горячее с локальными продуктами Северо-Запада, авторские десерты. К ужину — вино из разнообразной карты или авторские коктейли с видом. Средний чек романтического ужина — от 3 500 ₽ на человека.",
      },
      {
        heading: "Как забронировать столик",
        body: "Бронирование онлайн через сайт или по телефону +7 (812) 991-10-90. При бронировании сообщите, что планируется романтический ужин — менеджер зарезервирует лучший столик и уточнит детали сюрприза. Для особых случаев рекомендуем бронировать за 5–7 дней, особенно на выходные и закатное время.",
        highlight: "Сообщите о поводе при бронировании — это позволит подготовить украшение стола и сюрприз заранее.",
      },
    ],
    cta: { text: "Забронировать романтический ужин", href: "/romanticheskiy-uzhin" },
  },
  {
    slug: "romanticheskiy-vecher-spb",
    title: "Где провести романтический вечер в Петербурге: идеи и места",
    metaTitle: "Романтический вечер в Петербурге 2026 — Паруса на крыше",
    metaDescription: "Лучшие идеи для романтического вечера в СПб: ужин на крыше с видом, закат, живая музыка. Паруса на крыше — панорамный ресторан в центре города. Звоните: +7 (812) 991-10-90.",
    keywords: "романтический вечер спб, где провести романтический вечер петербург, вечер для двоих спб, романтика петербург 2026",
    date: "2026-03-12",
    category: "Романтика",
    readTime: 6,
    image: "/photos/view_night.webp",
    lead: "Петербург — один из самых романтичных городов мира, и выбор мест для особого вечера здесь огромен. Но среди всех вариантов ужин на крыше с панорамным видом занимает особое место: вид на закат над куполами, живая музыка и атмосфера высоты создают вечер, который запоминается навсегда.",
    sections: [
      {
        heading: "Что делает вечер по-настоящему романтичным",
        body: "Романтика складывается не из набора атрибутов, а из ощущения исключительности момента. Место, которое видел с земли тысячу раз, выглядит совершенно иначе с высоты. Панорама Петербурга на закате — именно такое впечатление: знакомый город открывается заново. Именно поэтому рестораны с видом неизменно лидируют в запросах «куда сходить на романтический вечер в Петербурге».",
      },
      {
        heading: "Варианты романтического вечера в Петербурге",
        body: "В Петербурге есть несколько популярных форматов для особого вечера: прогулка по крышам, теплоход по Неве в белые ночи, ужин в джаз-клубе или на панорамной террасе. Каждый из них по-своему хорош, но ужин на крыше выигрывает: здесь сочетаются вид, еда, музыка и комфорт — без необходимости переезжать между точками.",
        list: [
          "Ужин на крыше с панорамой — вид, кухня и музыка в одном месте",
          "Прогулка на теплоходе — красиво, но нет ресторанного комфорта",
          "Джаз-клуб — музыка, но без вида на город",
          "Крыши города (экскурсия) — романтично, но без ужина",
        ],
      },
      {
        heading: "Вечер в «Паруса на крыше»: как это устроено",
        body: "«Паруса на крыше» на ул. Марата, 5 — ресторан на 6-м этаже с панорамой на 300° на исторический центр Петербурга. Для романтического вечера здесь предусмотрено несколько форматов: ужин при свечах у панорамного окна, столик на открытой террасе в тёплый сезон, специальное меню для двоих. Живая музыка — по пятницам и субботам.",
        highlight: "Рейтинг 5,0 на Яндекс Картах (2 606 отзывов) — один из лучших показателей среди ресторанов Петербурга.",
      },
      {
        heading: "Лучшее время для романтического вечера",
        body: "Закат в Петербурге — особое время года: с мая по август солнце садится поздно, небо горит оранжевым и розовым, город подсвечивается. В белые ночи сумерки не заканчиваются до 23–24 часов — это лучшее время для романтического ужина на открытой террасе. Зимой и осенью атмосферу создаёт ночная подсветка куполов и мостов.",
      },
      {
        heading: "Как спланировать вечер",
        body: "Бронируйте столик заранее — не менее чем за 3–5 дней для обычного ужина и за неделю для особого случая (предложение, годовщина). Сообщите о поводе при бронировании — ресторан подготовит украшение стола и сюрприз. Оптимальное время прихода — за 30 минут до заката.",
      },
    ],
    cta: { text: "Забронировать вечер на крыше", href: "/romanticheskiy-uzhin" },
  },
  {
    slug: "predlozhenie-na-kryshe-spb",
    title: "Предложение руки и сердца на крыше в Петербурге",
    metaTitle: "Предложение на крыше СПб — Паруса на крыше | Помощь со сценарием",
    metaDescription: "Организуем предложение руки и сердца на крыше с видом на Петербург: сценарий, столик, сюрприз, фотограф. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "предложение на крыше спб, предложение руки и сердца петербург, помолвка на крыше, сделать предложение в ресторане спб",
    date: "2026-03-14",
    category: "Романтика",
    readTime: 6,
    image: "/photos/view_sunset.webp",
    lead: "Предложение руки и сердца на крыше с панорамным видом на Петербург — это момент, который партнёр запомнит на всю жизнь. «Паруса на крыше» организуют полный сценарий: особый столик, сюрприз, живая музыка в нужный момент и помощь с фотографом.",
    sections: [
      {
        heading: "Почему крыша — идеальное место для предложения",
        body: "Высота и панорама создают исключительность момента: всё, что происходит на фоне города с высоты птичьего полёта, воспринимается иначе. Вид на закат над Петербургом, купола и крыши исторического центра — это декорация, которую не создать ни в одном другом ресторане. И когда к этому виду добавляется кольцо — момент становится незабываемым.",
      },
      {
        heading: "Как организует предложение «Паруса на крыше»",
        body: "Ресторан берёт на себя подготовку: по предварительной договорённости менеджер поможет выбрать столик, согласовать момент, организовать живую музыку и украшение стола. Можно добавить шампанское в нужный момент, торт с надписью или цветы. Команда ресторана проводила десятки таких вечеров и знает, как сделать момент незабываемым.",
        list: [
          "Лучший столик у панорамного окна — забронируем заранее",
          "Живая музыка в момент предложения — по запросу",
          "Шампанское, цветы и торт — всё согласуем при бронировании",
          "Помощь с рекомендацией фотографа",
        ],
      },
      {
        heading: "Тайминг и лучшее время",
        body: "Лучшее время для предложения — закат. В Петербурге с мая по август закат наступает после 21:00, небо загорается красным и оранжевым — идеальный фон. В белые ночи сумерки растягиваются на несколько часов. Для зимнего предложения подходит вечерняя панорама с подсветкой куполов и мостов — не менее эффектно.",
        highlight: "Планируйте бронирование за 7–10 дней — особые столики разбирают быстро, особенно в пятницу и субботу.",
      },
      {
        heading: "Сценарий для предложения: с чего начать",
        body: "Чтобы подготовить предложение, свяжитесь с рестораном по телефону +7 (812) 991-10-90 или напишите в мессенджер. Менеджер уточнит ваши пожелания, предложит варианты оформления стола и согласует детали. Сообщите, хотите ли вы сюрприз (чтобы партнёр не знал) или хотите прийти уже зная о планах — и под это выстроят сценарий.",
      },
    ],
    cta: { text: "Организовать особый вечер", href: "/romanticheskiy-uzhin" },
  },
  {
    slug: "uzhin-pri-svechah-spb",
    title: "Ужин при свечах с панорамным видом в Петербурге",
    metaTitle: "Ужин при свечах СПб с видом на город — Паруса на крыше",
    metaDescription: "Ужин при свечах с панорамным видом на Петербург в ресторане на крыше. Столик у окна, свечи, закат и авторская кухня. Забронировать: +7 (812) 991-10-90.",
    keywords: "ужин при свечах спб, ужин при свечах с видом, романтический ужин при свечах, столик при свечах петербург",
    date: "2026-03-16",
    category: "Романтика",
    readTime: 5,
    image: "/photos/interior.webp",
    lead: "Ужин при свечах с видом на крыши Петербурга — одно из самых атмосферных впечатлений, которые может предложить город. В «Паруса на крыше» по предварительной заявке накрывают именной романтический столик со свечами, живыми цветами и панорамой за окном.",
    sections: [
      {
        heading: "Что включает романтический столик",
        body: "По запросу при бронировании ресторан организует: свечи на столе, живые цветы или лепестки роз, именные карточки и специальное меню для двоих. Шампанское или вино подаётся комплиментом от ресторана для особых случаев — уточняйте при бронировании. Столик у панорамного окна с видом на исторический центр — место, которое само по себе создаёт атмосферу.",
        list: [
          "Свечи и живые цветы по запросу",
          "Именные карточки и особое оформление",
          "Столик у панорамного окна — лучший вид на город",
          "Шампанское как комплимент для особых поводов",
        ],
      },
      {
        heading: "Меню для романтического ужина",
        body: "Авторское меню шефа включает блюда из локальных продуктов Северо-Запада: балтийская рыба, карельские грибы, сезонные овощи. Для ужина при свечах подходят лёгкие закуски, основные блюда и авторские десерты — всё рассчитано на неспешный вечер. Карта вин — от петербургских крафтовых позиций до классических итальянских.",
      },
      {
        heading: "Вид как часть ужина",
        body: "«Паруса на крыше» расположены на 6-м этаже с панорамой на 300° на исторический центр Петербурга. За окном — крыши, купола, силуэт Исаакиевского собора. В белые ночи вечер продолжается при мягком свете над городом; в зимнее время — при подсветке куполов. Открытая терраса работает с мая по сентябрь.",
        highlight: "Бронируйте столик у окна заранее — их всего несколько, и в выходные дни они заняты.",
      },
      {
        heading: "Как забронировать",
        body: "Звоните по +7 (812) 991-10-90 или бронируйте онлайн на сайте. Обязательно сообщите о поводе — менеджер уточнит детали оформления и согласует всё заранее. Для особых случаев (предложение, годовщина, день рождения) рекомендуем звонить, а не бронировать онлайн — так можно согласовать больше деталей.",
      },
    ],
    cta: { text: "Забронировать ужин при свечах", href: "/romanticheskiy-uzhin" },
  },
  {
    slug: "idei-dlya-svidaniya-spb",
    title: "Идеи для свидания в Петербурге: необычные и романтичные места",
    metaTitle: "Идеи для свидания в СПб 2026 — необычные места | Паруса на крыше",
    metaDescription: "Топ идей для романтического свидания в Петербурге: крыша с панорамой, закат над городом, живая музыка. Паруса на крыше — лучшее место для особого вечера. +7 (812) 991-10-90.",
    keywords: "идеи для свидания спб, необычное свидание петербург, романтические места спб, свидание на высоте петербург",
    date: "2026-03-18",
    category: "Романтика",
    readTime: 7,
    image: "/photos/view_clouds.webp",
    lead: "Петербург богат романтическими местами, но большинство туристических вариантов давно примелькались. Если хочется по-настоящему запомнившегося свидания — стоит подняться выше привычных маршрутов. Буквально: на крышу.",
    sections: [
      {
        heading: "Почему обычные места перестают удивлять",
        body: "Кофейня на Рубинштейна, прогулка по набережной, кино в мультиплексе — всё это хорошо, но не создаёт исключительности. А для первого свидания или особой встречи нужно место, которое само по себе становится событием. Необычная точка обзора, неожиданный вид или формат, которого раньше не было — вот что запоминается.",
      },
      {
        heading: "ТОП идей для свидания в Петербурге",
        body: "Петербург предлагает несколько форматов, которые действительно работают для романтического свидания.",
        list: [
          "Ужин на крыше с панорамой — вид, кухня, атмосфера в одном месте",
          "Экскурсия по крышам — романтично, но без ужина и в любую погоду",
          "Теплоход в белые ночи — красиво, но ограниченный сервис",
          "Джаз-клуб — музыка и атмосфера, без вида на город",
          "Мастер-класс по кулинарии — необычно, но не про виды",
          "Закат на смотровой площадке — бесплатно, но без ужина",
        ],
      },
      {
        heading: "Ужин на крыше: почему это работает лучше всего",
        body: "Ресторан «Паруса на крыше» объединяет всё, что нужно для идеального свидания: высоту, вид, хорошую еду и музыку. Здесь не нужно организовывать несколько точек маршрута — один вечер в правильном месте перекрывает всё. Рейтинг 5,0 на Яндексе говорит о том, что гости раз за разом выбирают именно этот формат.",
        highlight: "Для первого свидания особенно хорошо подходит столик у панорамного окна — есть о чём говорить, когда за окном весь Петербург.",
      },
      {
        heading: "Как выбрать лучшее время",
        body: "Закат и белые ночи — лучшее время для свидания на крыше. С мая по август солнце садится поздно, небо горит оранжевым, город подсвечивается. Бронируйте за 3–5 дней и уточняйте, в какое время в этот день закат — менеджер подскажет лучший час для прихода.",
      },
      {
        heading: "Бюджет и бронирование",
        body: "Ужин на двоих в «Паруса на крыше» — от 5 000–7 000 ₽ в зависимости от выбора меню. Это вполне разумный бюджет для особого вечера, который точно запомнится. Бронирование онлайн или по телефону +7 (812) 991-10-90.",
      },
    ],
    cta: { text: "Забронировать столик на свидание", href: "/romanticheskiy-uzhin" },
  },
  {
    slug: "restoran-na-kryshe-spb",
    title: "Ресторан на крыше в Санкт-Петербурге: куда пойти",
    metaTitle: "Ресторан на крыше СПб — куда пойти в 2026 | Паруса на крыше",
    metaDescription: "Лучший ресторан на крыше в Санкт-Петербурге с панорамным видом на город. «Паруса на крыше» — 6 этаж, вид 300°, авторская кухня, открытая терраса. +7 (812) 991-10-90.",
    keywords: "ресторан на крыше спб, рестораны на крышах санкт-петербург, куда пойти на крышу спб, панорамный ресторан петербург",
    date: "2026-03-20",
    category: "Ресторан",
    readTime: 7,
    image: "/photos/view_day.webp",
    lead: "Ресторан на крыше в Петербурге — это не просто место для ужина, это впечатление. Панорама над городом, воздух высоты, закат над куполами — всё это меняет восприятие вечера. Если ищете ресторан на крыше в Санкт-Петербурге, вот что нужно знать.",
    sections: [
      {
        heading: "На что обратить внимание при выборе",
        body: "Не все «рестораны на крыше» одинаковы. Главное — реальный открытый вид, а не название. Важно: высота и охват панорамы, наличие открытой террасы, качество кухни и сервиса, репутация заведения. Вид быстро приедается, если еда слабая — ищите баланс.",
        list: [
          "Реальная открытая панорама — не вид во двор",
          "Открытая терраса для тёплого сезона",
          "Авторская кухня — а не просто фоновый ресторан",
          "Рейтинг выше 4,5 на картах и проверенные отзывы",
        ],
      },
      {
        heading: "«Паруса на крыше» — выбор петербуржцев с 2009 года",
        body: "Ресторан «Паруса на крыше» на ул. Марата, 5 работает с 2009 года. За 6-й этаж Olympic Plaza с панорамой на 300° на исторический центр — купола Исаакиевского, крыши Центрального района, силуэт Казанского. Рейтинг 5,0 на Яндекс Картах (2 606 отзывов) и 4,9 на 2ГИС (более 800 отзывов). Лучший ресторан с видом по версии Time Out.",
        highlight: "Бронирование доступно онлайн на сайте или по телефону +7 (812) 991-10-90.",
      },
      {
        heading: "Что видно с крыши",
        body: "С 6-го этажа Olympic Plaza открывается вид на исторический центр Петербурга: силуэт Исаакиевского собора, купола и крыши Центрального района, линия горизонта. В ясную погоду виден Финский залив. На закате и в белые ночи панорама становится особенно эффектной.",
      },
      {
        heading: "Открытая терраса и сезонность",
        body: "Летняя открытая терраса «Парусов» работает с мая по сентябрь — лучшее место для ужина в тёплый сезон. Зимой ресторан работает в тёплом зале с панорамными окнами — вид сохраняется круглый год. В белые ночи терраса особенно популярна: свет не уходит до полуночи.",
      },
      {
        heading: "Форматы посещения",
        body: "«Паруса на крыше» подходят для разных форматов: романтический ужин для двоих, встреча с друзьями, деловой обед, банкет или свадьба. Вместимость — до 300 человек. Бизнес-ланч — понедельник–пятница с 12:00 до 16:00 от 590 ₽.",
      },
    ],
    cta: { text: "Забронировать столик на крыше", href: "/" },
  },
  {
    slug: "panoramnyy-restoran-spb",
    title: "Лучший панорамный ресторан в Петербурге: как выбрать",
    metaTitle: "Панорамный ресторан СПб — лучший выбор 2026 | Паруса на крыше",
    metaDescription: "Ищете панорамный ресторан в Петербурге? «Паруса на крыше» — вид 300° на центр города, открытая терраса, авторская кухня, банкеты и свадьбы. Бронь: +7 (812) 991-10-90.",
    keywords: "панорамный ресторан спб, ресторан с панорамным видом, ресторан с видом на город спб, панорама петербурга ресторан",
    date: "2026-03-22",
    category: "Ресторан",
    readTime: 7,
    image: "/photos/view_summer.webp",
    lead: "Лучший панорамный ресторан в Петербурге — это верхний этаж, открытый вид на город, терраса для заката и кухня уровня «ради вида не приходится терпеть еду». «Паруса на крыше» сочетают панораму на центр, открытую террасу и авторское меню — плюс площадку для свадеб и банкетов.",
    sections: [
      {
        heading: "Что делает панорамный ресторан лучшим",
        body: "Слово «панорамный» в названии — не гарантия вида. Важно проверить несколько вещей: насколько реальна панорама (а не окно во двор), есть ли открытая терраса, какое качество кухни. Хороший панорамный ресторан — это баланс: вид + еда + сервис. Только видом сыт не будешь, а плохая еда смазывает даже самую красивую панораму.",
      },
      {
        heading: "Вид: что открывается с крыши",
        body: "«Паруса на крыше» на 6-м этаже Olympic Plaza (ул. Марата, 5) открывают вид на 300° на исторический центр Петербурга: силуэт Исаакиевского собора, купола Троицкой церкви, бесконечная черепица крыш Центрального района. На закате небо горит оранжевым — лучший момент для фотографий и просто для взгляда из окна.",
      },
      {
        heading: "Кухня и атмосфера",
        body: "Шеф работает с локальными продуктами Северо-Запада: балтийская рыба, карельские грибы, сезонные овощи. Авторское меню меняется сезонно. Винная карта — от петербургских крафтовых позиций до грузинских и итальянских вин. Атмосфера подходит для романтического ужина, деловой встречи и праздника одновременно.",
        highlight: "Рейтинг 5,0 на Яндекс Картах и «Лучший ресторан с видом» по версии Time Out.",
      },
      {
        heading: "Чек-лист выбора панорамного ресторана",
        body: "Пользуйтесь этим списком при выборе:",
        list: [
          "Верхний этаж с реальным открытым видом",
          "Открытая терраса для закатного сезона",
          "Авторская кухня — не стандартное меню",
          "Рейтинг выше 4,5 на Яндекс Картах",
          "Возможность банкета или бронирования на событие",
        ],
      },
      {
        heading: "Форматы посещения",
        body: "«Паруса на крыше» принимают: романтические ужины для двоих, встречи с компанией до 300 человек, свадьбы, банкеты, дни рождения и корпоративы. Бизнес-ланч — будни 12:00–16:00. Открытая терраса — май–сентябрь.",
      },
    ],
    cta: { text: "Забронировать столик с панорамой", href: "/" },
  },

  // ─── ВОЛНА 2 (апрель 2026) ───────────────────────────────────────────────────
  {
    slug: "vid-na-kryshi-peterburga",
    title: "Ужин с видом на крыши Петербурга: где и как",
    metaTitle: "Ужин с видом на крыши Петербурга — Паруса на крыше СПб",
    metaDescription: "Ужин с видом на крыши Петербурга в ресторане на 6 этаже: панорама исторического центра, закат, открытая терраса. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "вид на крыши петербурга, ужин с видом на крыши, крыши петербурга ресторан, вид сверху на город спб",
    date: "2026-04-01",
    category: "Ресторан",
    readTime: 6,
    image: "/photos/view_day.webp",
    lead: "Вид на крыши Петербурга с высоты — особый угол зрения на город, который знакомо видели с земли. Черепица, купола, вентиляционные башенки, редкие сады на крышах — всё это открывается только сверху. Ресторан «Паруса на крыше» позволяет совместить этот вид с полноценным ужином.",
    sections: [
      {
        heading: "Что такое «вид на крыши»",
        body: "Крыши Петербурга — отдельный пласт города, скрытый от большинства горожан и туристов. С высоты видно то, что не замечаешь с улицы: геометрию кварталов, перепад высот исторических зданий, силуэты колоколен и куполов на горизонте. «Паруса на крыше» расположены на 6-м этаже — высоте, с которой крыши центра видны именно так.",
      },
      {
        heading: "Что открывается с 6-го этажа",
        body: "С панорамных окон и открытой террасы ресторана видно: купола Исаакиевского и Казанского соборов, черепичные крыши Центрального района, силуэт Смольного собора на горизонте, в ясную погоду — Финский залив. Панорама охватывает 300° — практически полный обзор центра города.",
        highlight: "Лучшие столики с видом — у панорамных окон. Бронируйте конкретный стол при звонке в ресторан.",
      },
      {
        heading: "Ужин как способ провести время с видом",
        body: "В отличие от смотровых площадок и крышных экскурсий, в ресторане с видом можно провести несколько часов: неспешно поужинать, поговорить, посмотреть, как меняется свет за окном от закатного до ночного. Никакого лимита по времени — просто вечер с видом.",
      },
      {
        heading: "Открытая терраса: вид без стекла",
        body: "В тёплый сезон (май–сентябрь) работает открытая терраса — там вид на крыши города без стекла, с воздухом и звуком города. Это лучшее место для фотографий и для тех, кто хочет максимальный эффект присутствия на высоте.",
      },
    ],
    cta: { text: "Забронировать столик с видом", href: "/terrasa" },
  },
  {
    slug: "zakat-v-peterburge",
    title: "Где посмотреть на закат в Петербурге: лучшие места",
    metaTitle: "Закат в Петербурге — где смотреть в 2026 | Паруса на крыше",
    metaDescription: "Лучшие места для заката в Петербурге: панорамная крыша, терраса с видом, ужин на закате. «Паруса на крыше» — ресторан с самым красивым закатом над городом. +7 (812) 991-10-90.",
    keywords: "закат в петербурге, где посмотреть закат спб, ужин на закате петербург, закат над городом",
    date: "2026-04-03",
    category: "Виды и атмосфера",
    readTime: 6,
    image: "/photos/view_sunset.webp",
    lead: "Закат в Петербурге — одно из главных визуальных событий города. С мая по август небо над историческим центром горит оранжевым и розовым, и лучшая точка для наблюдения — высота: крыши, террасы, верхние этажи. Вот где именно смотреть закат в Петербурге.",
    sections: [
      {
        heading: "Когда в Петербурге лучший закат",
        body: "Летом в Петербурге солнце садится поздно: в июне — около 23:00, в мае и июле — около 22:00–22:30. Небо начинает гореть за час до захода, а «золотой час» — самый красивый свет для фотографий — длится около 40 минут. После заката начинаются белые ночи: сумерки, а не темнота, что создаёт особую атмосферу ещё на несколько часов.",
        highlight: "Лучшие месяцы для заката в Петербурге: май, июнь, июль. Пик — середина июня (белые ночи).",
      },
      {
        heading: "Лучшие места для заката в городе",
        body: "В Петербурге есть несколько популярных точек для наблюдения за закатом.",
        list: [
          "Крыши и панорамные рестораны — самый комфортный вариант с едой",
          "Стрелка Васильевского острова — открытый вид, но без крыши и еды",
          "Исаакиевский собор (колоннада) — красиво, но закрывается рано",
          "Набережная Невы — горизонтальный вид, не с высоты",
          "Лахта Центр — высоко, но далеко от центра",
        ],
      },
      {
        heading: "Закат с крыши: почему это лучший вариант",
        body: "Ресторан «Паруса на крыше» — одна из лучших точек для заката в центре Петербурга. С 6-го этажа открывается вид на 300° — небо занимает большую часть обзора, на горизонте видны силуэты куполов. Особенность: можно ужинать и одновременно наблюдать, как меняется свет — не стоять на смотровой, а сидеть за столиком с бокалом вина.",
      },
      {
        heading: "Как спланировать ужин на закате",
        body: "Уточните время заката на нужный день (меняется каждый день). Приходите за 30–40 минут до захода — это лучшее освещение. Бронируйте столик у окна или на террасе заранее: закатные места разбирают быстро, особенно в белые ночи. Телефон: +7 (812) 991-10-90.",
      },
    ],
    cta: { text: "Забронировать закатный столик", href: "/terrasa" },
  },
  {
    slug: "vid-na-isaakievskiy-sobor",
    title: "Ресторан с видом на Исаакиевский собор в Петербурге",
    metaTitle: "Ресторан с видом на Исаакиевский собор СПб — Паруса на крыше",
    metaDescription: "Ресторан с видом на Исаакиевский собор в Петербурге: панорама исторического центра, ужин с видом, открытая терраса. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "вид на исаакиевский собор, ресторан с видом на исаакий, столик с видом на исаакиевский, панорама исаакиевского",
    date: "2026-04-05",
    category: "Виды и атмосфера",
    readTime: 5,
    image: "/photos/view_day.webp",
    lead: "Исаакиевский собор — главный силуэт Петербурга, который виден с десятков точек города. Но увидеть его с высоты, на фоне закатного неба, за бокалом вина — это другое впечатление. «Паруса на крыше» расположены на 6-м этаже в историческом центре — именно отсюда открывается тот самый вид.",
    sections: [
      {
        heading: "Вид на Исаакиевский с крыши ресторана",
        body: "С панорамных окон и террасы «Парусов» видно силуэт Исаакиевского собора на горизонте — один из главных ориентиров центра Петербурга. Рядом в панораме: крыши исторического центра, купола Троицкой и Казанской церквей, Московский проспект вдаль. Это вид, который знают по открыткам, но который по-настоящему впечатляет только с высоты.",
        highlight: "На закате Исаакиевский светится особенно — золочёный купол на фоне оранжевого неба. Лучшее время для прихода — за час до заката.",
      },
      {
        heading: "Как организован ресторан",
        body: "«Паруса на крыше» работают с 2009 года на 6-м этаже Olympic Plaza (ул. Марата, 5). Панорама — 300° на исторический центр. Авторская кухня, открытая терраса (май–сентябрь), живая музыка по пятницам и субботам. Подходит для романтического ужина, встречи с друзьями, банкета.",
      },
      {
        heading: "Почему именно этот ракурс",
        body: "Исаакиевский собор принято видеть снизу вверх с площади или Невы. Но с высоты он становится частью панорамы, горизонтом города — и это совершенно другое восприятие. Особенно в сочетании с закатным светом, когда золочёный купол буквально светится. Для петербуржцев это знакомый вид в новом ракурсе, для туристов — открытие.",
      },
      {
        heading: "Бронирование и цены",
        body: "Столик у панорамного окна с видом на Исаакиевский — бронируется отдельно при звонке в ресторан +7 (812) 991-10-90. Средний чек — от 2 500 ₽. Бизнес-ланч (будни 12:00–16:00) — от 590 ₽.",
      },
    ],
    cta: { text: "Забронировать столик с видом", href: "/" },
  },
  {
    slug: "panoramnaya-terrasa-spb",
    title: "Панорамная терраса в Санкт-Петербурге: открытая веранда на крыше",
    metaTitle: "Панорамная терраса СПб — открытая терраса на крыше | Паруса на крыше",
    metaDescription: "Панорамная открытая терраса на крыше в Петербурге с видом 300° на центр города. Рестораны и закаты с высоты. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "панорамная терраса спб, открытая терраса с видом, терраса на крыше петербург, летняя терраса спб",
    date: "2026-04-07",
    category: "Виды и атмосфера",
    readTime: 6,
    image: "/photos/terrace.webp",
    lead: "Открытая панорамная терраса на крыше — летний формат, который в Петербурге ценится особо: с мая по сентябрь погода позволяет ужинать на свежем воздухе с видом на весь исторический центр. «Паруса на крыше» предлагают именно такую террасу — без стекла, с максимальным обзором.",
    sections: [
      {
        heading: "Чем терраса отличается от зала с видом",
        body: "Панорамный ресторан с видом через окно и открытая терраса — разные ощущения. На террасе нет стекла: есть ветер, воздух высоты, звук города снизу и небо над головой. Это максимальный эффект «над городом» — именно за ним приходят на открытые веранды. Фотографии с террасы получаются иначе — нет бликов от стекла, горизонт выглядит чище.",
      },
      {
        heading: "Терраса «Паруса на крыше»: что и как",
        body: "Открытая терраса ресторана работает с мая по сентябрь — в зависимости от погоды. Вид с неё — 300° на исторический центр Петербурга: крыши, купола, горизонт. Столики расставлены так, чтобы у каждого был вид. В дождь или холодный вечер гостей пересаживают в тёплый зал с панорамными окнами.",
        highlight: "Терраса — лучшее место в период белых ночей (июнь–начало июля): долгие сумерки, подсветка города и вид без стекла.",
      },
      {
        heading: "Как забронировать место на террасе",
        body: "Места на открытой террасе бронируются отдельно — при звонке попросите столик на террасе. Летом они разбираются быстро, особенно на закатное время. Бронирование: +7 (812) 991-10-90 или онлайн на сайте.",
      },
      {
        heading: "Что подходит для террасы",
        body: "Открытая терраса подходит для: романтического ужина на двоих, встречи с друзьями, делового ланча в тёплый день, фотосессии на фоне панорамы. Для больших компаний (8+ человек) — уточняйте наличие мест на террасе заранее.",
        list: [
          "Романтический ужин с закатом",
          "Вечер с друзьями в белые ночи",
          "Деловой обед с панорамой",
          "Фотосессия с видом на Петербург",
        ],
      },
    ],
    cta: { text: "Забронировать место на террасе", href: "/terrasa" },
  },
  {
    slug: "veranda-na-kryshe-spb",
    title: "Ресторан с открытой верандой на крыше в Петербурге",
    metaTitle: "Открытая веранда на крыше СПб — ресторан с видом | Паруса на крыше",
    metaDescription: "Ресторан с открытой верандой на крыше в Петербурге: вид на центр города, ужин на свежем воздухе, сезон май–сентябрь. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "веранда на крыше спб, открытая веранда ресторан, веранда с видом на город, летняя веранда петербург",
    date: "2026-04-09",
    category: "Виды и атмосфера",
    readTime: 5,
    image: "/photos/terrace.webp",
    lead: "Открытая веранда на крыше — редкий формат для Петербурга, который появляется только в тёплый сезон. В ресторане «Паруса на крыше» веранда работает с мая по сентябрь: свежий воздух, вид на исторический центр без стекла и ужин над городом.",
    sections: [
      {
        heading: "Чем хороша открытая веранда",
        body: "Веранда на крыше — это другой ресторанный опыт. Нет закрытого помещения, есть небо над головой, городской воздух и звук Петербурга снизу. Для ужина это создаёт особую атмосферу: непринуждённую, летнюю, городскую. Особенно хорошо — в белые ночи, когда сумерки тянутся до полуночи.",
      },
      {
        heading: "Сезон и погода",
        body: "Открытая веранда «Парусов» работает с мая по сентябрь при хорошей погоде. В Петербурге лето непредсказуемо, поэтому веранду закрывают при дожде или сильном ветре — гостей пересаживают в тёплый зал с тем же видом через панорамные окна. Лучший сезон — июнь и июль (белые ночи и более тёплая погода).",
        highlight: "В дождь и холод гостей без доплаты пересаживают в основной зал с панорамными окнами.",
      },
      {
        heading: "Виды с открытой веранды",
        body: "С веранды «Паруса на крыше» открывается полный 300-градусный обзор на исторический центр: крыши Центрального района, купола, горизонт с Исаакиевским собором. Без стекла — максимальный эффект присутствия на высоте. Лучшее время — закат и сумерки белых ночей.",
      },
      {
        heading: "Бронирование",
        body: "Места на открытой веранде бронируются при звонке: +7 (812) 991-10-90. Онлайн-бронирование доступно на сайте. Для веранды рекомендуем бронировать за 3–5 дней в сезон — места разбирают быстро.",
      },
    ],
    cta: { text: "Забронировать место на веранде", href: "/terrasa" },
  },

  // ─── ВОЛНА 3 (апрель 2026) ───────────────────────────────────────────────────
  {
    slug: "belye-nochi-na-kryshe",
    title: "Белые ночи на крыше в Петербурге: где встретить",
    metaTitle: "Белые ночи на крыше Петербурга — Паруса на крыше | СПб",
    metaDescription: "Белые ночи на крыше Петербурга: ужин на открытой террасе, закат, долгие сумерки. «Паруса на крыше» — лучшее место в сезон белых ночей. Бронь: +7 (812) 991-10-90.",
    keywords: "белые ночи на крыше, белые ночи ресторан спб, ужин в белые ночи, где встретить белые ночи",
    date: "2026-04-12",
    category: "Виды и атмосфера",
    readTime: 6,
    image: "/photos/view_night.webp",
    lead: "Белые ночи на крыше в Петербурге — особое переживание: долгие сумерки над городом, подсветка куполов, закат, который почти не заканчивается. «Паруса на крыше» принимают гостей в этот сезон на открытой террасе — лучшем месте для наблюдения за белыми ночами в центре города.",
    sections: [
      {
        heading: "Что такое белые ночи и когда они",
        body: "Белые ночи в Петербурге — период с конца мая по середину июля, когда ночь почти не темнеет. В пик сезона (около 21 июня) солнце заходит в 23:00 и встаёт в 3:00 — темноты практически нет. Это лучшее время для крыши: панорама работает дольше, закат плавно переходит в подсвеченный город.",
        highlight: "Пик белых ночей — с 11 по 24 июня. Темнее всего в эти недели — около 0:30–1:00.",
      },
      {
        heading: "Почему именно крыша",
        body: "С высоты белые ночи раскрываются иначе: видна линия горизонта, силуэты центра, мягкий свет над городом. Открытая терраса «Парусов» даёт обзор без стекла — то, ради чего поднимаются наверх. На земле белые ночи красивы, но с крыши — масштаб совсем другой.",
      },
      {
        heading: "Как спланировать вечер в белые ночи",
        body: "Бронируйте столик на террасе на закатное и пред-закатное время. Закажите ужин, оставайтесь до ночной панорамы — в белые ночи можно сидеть на террасе и в полночь. Возьмите лёгкий слой одежды: на высоте прохладнее, особенно к ночи. Лучшие фото — в час заката и в синие сумерки.",
        list: [
          "Бронируйте стол на террасе за 5–7 дней",
          "Приходите за час до заката — самый красивый свет",
          "Оставайтесь до сумерек белых ночей",
          "Возьмите тёплую накидку — на высоте прохладно",
        ],
      },
      {
        heading: "Тайминг вечера белых ночей",
        body: "В июне закат наступает около 23:00. Приходите в 21:30–22:00 — это золотой час. После заката начинаются сумерки белых ночей: мягкий голубоватый свет над городом сохраняется ещё 2–3 часа. Ужин на террасе растягивается на весь этот период.",
      },
    ],
    cta: { text: "Забронировать столик в белые ночи", href: "/terrasa" },
  },
  {
    slug: "rassvet-v-peterburge",
    title: "Где встретить рассвет в Петербурге: лучшие точки",
    metaTitle: "Рассвет в Петербурге — где встретить 2026 | Паруса на крыше",
    metaDescription: "Рассвет в Петербурге: лучшие точки с высоты, панорамная терраса, крыша с видом. «Паруса на крыше» — ресторан для особого утра над городом. +7 (812) 991-10-90.",
    keywords: "рассвет в петербурге, где встретить рассвет спб, рассвет над городом, утро на крыше петербург",
    date: "2026-04-14",
    category: "Виды и атмосфера",
    readTime: 5,
    image: "/photos/view_summer.webp",
    lead: "Рассвет в Петербурге в белые ночи — особое событие: в середине июня солнце встаёт уже в 3:00–3:30. С высоты это зрелище совсем другое, чем с уровня улицы. Крыша с панорамным видом — идеальная точка, чтобы встретить рассвет над историческим центром.",
    sections: [
      {
        heading: "Когда и как рассвет в Петербурге",
        body: "В период белых ночей (конец мая — середина июля) рассвет в Петербурге происходит очень рано: в середине июня солнце встаёт около 3:30–3:45. В эти дни нет настоящей ночи — только долгие сумерки, которые плавно переходят в рассвет. Это и делает рассвет с крыши Петербурга таким особенным.",
      },
      {
        heading: "Лучшие точки для рассвета",
        body: "Чтобы встретить рассвет красиво, нужна высота и открытый горизонт.",
        list: [
          "Панорамная крыша ресторана — самый комфортный вариант",
          "Крыши домов по экскурсии — холодно и без еды",
          "Набережная Невы — красиво, но без высоты",
          "Колоннада Исаакиевского — закрыта в 3:00 утра",
        ],
      },
      {
        heading: "Рассвет с террасы «Паруса на крыше»",
        body: "В белые ночи терраса «Парусов» может использоваться для встречи рассвета — уточняйте возможность поздней брони по телефону. Вид с 6-го этажа на восток — это линия горизонта с первыми лучами солнца над крышами исторического центра. Редкое впечатление для тех, кто хочет провести белую ночь не в баре, а с видом.",
        highlight: "Для рассветного визита бронируйте заранее и уточняйте режим работы на конкретную дату — +7 (812) 991-10-90.",
      },
    ],
    cta: { text: "Спланировать особый вечер на крыше", href: "/terrasa" },
  },
  {
    slug: "razvod-mostov-spb-gde-smotret",
    title: "Развод мостов в Петербурге с крыши: где смотреть",
    metaTitle: "Развод мостов СПб — смотреть с крыши 2026 | Паруса на крыше",
    metaDescription: "Посмотреть развод мостов в Петербурге с крыши — панорамный ресторан в центре с видом на мосты и Неву. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "развод мостов спб где смотреть, посмотреть развод мостов, развод мостов с крыши, ночь разводных мостов",
    date: "2026-04-16",
    category: "Виды и атмосфера",
    readTime: 6,
    image: "/photos/view_night.webp",
    lead: "Развод мостов — одно из главных зрелищ Петербурга, которое собирает тысячи зрителей каждую навигационную ночь. Смотреть его с уровня набережной — классика. Смотреть с крыши — совсем другой масштаб и другое ощущение.",
    sections: [
      {
        heading: "Когда разводят мосты в Петербурге",
        body: "Разводка мостов в Петербурге проходит ежегодно с апреля по ноябрь, обычно с 01:00 до 05:00. Точное расписание — на сайте Комитета по развитию транспортной инфраструктуры СПб. Каждый мост разводят в своё время; на Неве в центре — Дворцовый и Благовещенский. Из ресторана на ул. Марата виден силуэт центральной части города с подсветкой.",
        highlight: "Расписание разводки мостов меняется каждый год — проверяйте на официальном сайте Петербурга.",
      },
      {
        heading: "Вид на мосты с крыши",
        body: "С 6-го этажа «Парусов на крыше» в ночное время видна панорама освещённого центра: подсветка мостов, Нева, купола в ночном свете. В ночь разводки рекомендуем бронировать столик на террасе или у окна с видом на запад — именно там открывается наилучший ракурс на ночной город.",
      },
      {
        heading: "Как провести ночь разводки мостов",
        body: "Один из форматов — поздний ужин с переходом в «белую ночь»: приходите к 21:00–22:00, ужинаете на закате и белой ночи, остаётесь до разводки. Это лучше, чем стоять на набережной: тепло, комфортно, с едой и напитками. Уточняйте режим работы ресторана при бронировании — +7 (812) 991-10-90.",
        list: [
          "Ужин на закате (21:30–22:30)",
          "Белая ночь на террасе (22:30–00:00)",
          "Ночная панорама мостов в подсветке",
        ],
      },
    ],
    cta: { text: "Забронировать ночной столик", href: "/terrasa" },
  },
  {
    slug: "smotrovye-ploshchadki-spb",
    title: "Лучшие смотровые площадки Петербурга: полный список 2026",
    metaTitle: "Смотровые площадки Петербурга 2026 — где лучший вид | Паруса на крыше",
    metaDescription: "Топ смотровых площадок в Санкт-Петербурге с лучшим видом на город: бесплатные, платные и ресторанные. «Паруса на крыше» — лучший вид с едой и сервисом. +7 (812) 991-10-90.",
    keywords: "смотровые площадки спб, лучшие виды петербурга, обзорная площадка спб, где красивый вид на город",
    date: "2026-04-18",
    category: "Виды и атмосфера",
    readTime: 8,
    image: "/photos/view_clouds.webp",
    lead: "Петербург — один из самых красивых городов мира с высоты. Здесь десятки точек с панорамным видом: смотровые площадки соборов, крыши исторических зданий, современные башни и панорамные рестораны. Разбираем все варианты.",
    sections: [
      {
        heading: "Смотровые площадки в центре Петербурга",
        body: "В историческом центре есть несколько официальных смотровых площадок с открытым видом.",
        list: [
          "Колоннада Исаакиевского собора — 43 м, вид на центр, работает с 10:30 до 18:00",
          "Колокольня Петропавловского собора — панорама на Неву и Петроградскую",
          "Смотровая Лахта Центра — 462 м, но далеко от центра",
          "Крыши по экскурсиям — романтично, но без сервиса",
        ],
      },
      {
        heading: "Панорамные рестораны как смотровые",
        body: "Лучший компромисс: смотровая площадка, где можно поесть. «Паруса на крыше» — ресторан на 6-м этаже Olympic Plaza (ул. Марата, 5) с панорамой 300° на исторический центр. Открытая терраса в тёплый сезон, авторская кухня, живая музыка. В отличие от классических смотровых — здесь можно провести весь вечер, а не 20 минут на ветру.",
        highlight: "«Паруса на крыше» — единственный панорамный ресторан в историческом центре с рейтингом 5,0 на Яндекс Картах.",
      },
      {
        heading: "Сравнение вариантов",
        body: "Выбор смотровой площадки зависит от ваших приоритетов.",
        list: [
          "Колоннада Исаакия — исторически красиво, но закрывается рано",
          "Лахта Центр — самая высокая точка, но далеко от центра",
          "Крыша по экскурсии — романтика, но без комфорта",
          "Ресторан на крыше — вид + еда + комфорт + живая музыка",
        ],
      },
      {
        heading: "Лучшее время для смотровых площадок",
        body: "Закат и белые ночи — лучшее время для любой смотровой в Петербурге. Для ресторана на крыше преимущество — можно прийти заранее, поужинать и дождаться нужного момента. Бронирование: +7 (812) 991-10-90.",
      },
    ],
    cta: { text: "Забронировать стол с лучшим видом", href: "/terrasa" },
  },
  {
    slug: "kuda-sxodit-v-belye-nochi",
    title: "Куда сходить в белые ночи в Петербурге: идеи 2026",
    metaTitle: "Куда сходить в белые ночи СПб 2026 — идеи | Паруса на крыше",
    metaDescription: "Что делать и куда сходить в белые ночи в Санкт-Петербурге: ужин на крыше, закат, прогулка. «Паруса на крыше» — лучшее место для белых ночей. +7 (812) 991-10-90.",
    keywords: "куда сходить в белые ночи, белые ночи программа спб, что делать в белые ночи, белые ночи петербург места",
    date: "2026-04-20",
    category: "Виды и атмосфера",
    readTime: 7,
    image: "/photos/view_night.webp",
    lead: "Белые ночи в Петербурге — один из главных туристических сезонов. В конце мая — середине июля город не темнеет, а возможностей для вечернего досуга больше, чем обычно. Разбираем лучшие идеи — для первого раза и для тех, кто в Петербурге живёт.",
    sections: [
      {
        heading: "Программа на белую ночь",
        body: "Стандартная программа белых ночей для гостей города: вечером — ужин или прогулка по набережной, после 22:00 — выйти на набережную Невы для развода мостов (около 01:00). Но это мало использует уникальность белых ночей: отсутствие темноты позволяет сделать гораздо больше.",
      },
      {
        heading: "Что сделать в белые ночи: список идей",
        body: "Идеи для разных аудиторий:",
        list: [
          "Ужин на крыше с закатом и белой ночью — ресторан «Паруса на крыше»",
          "Прогулка на теплоходе по Неве под белым небом",
          "Пешеходный маршрут по историческому центру вечером",
          "Развод мостов с набережной (01:00–04:00)",
          "Рассвет над городом с крыши (03:30–04:00)",
          "Концерт в Мариинском театре (специальные программы в сезон)",
        ],
      },
      {
        heading: "Ужин на крыше в белые ночи: почему это лучший вариант",
        body: "Из всех вариантов белых ночей ужин на крыше — самый комплексный: вид на закат и белую ночь, хорошая еда, живая музыка, комфорт. Не нужно организовывать несколько точек — один вечер в «Паруса на крыше» закрывает всё: закат, белая ночь, панорама, атмосфера.",
        highlight: "В сезон белых ночей столики на террасе разбирают за 5–7 дней — бронируйте заранее.",
      },
      {
        heading: "Для туристов и петербуржцев",
        body: "Для туристов: белые ночи — обязательный повод приехать в Петербург. Из всех активностей ужин с видом на закат — самое яркое впечатление. Для петербуржцев: это момент, когда стоит подняться выше привычного уровня и посмотреть на свой город сверху — в том свете, который бывает только раз в год.",
      },
    ],
    cta: { text: "Забронировать вечер в белые ночи", href: "/terrasa" },
  },

  // ─── ВОЛНА 4 (май 2026) ──────────────────────────────────────────────────────
  {
    slug: "svadba-na-kryshe-spb",
    title: "Свадьба на крыше в Петербурге: всё о формате",
    metaTitle: "Свадьба на крыше СПб — площадка и организация | Паруса на крыше",
    metaDescription: "Свадьба на крыше в Санкт-Петербурге: выездная регистрация, банкет, вид на город. «Паруса на крыше» — площадка на 300 гостей с панорамой. +7 (812) 991-10-90.",
    keywords: "свадьба на крыше спб, свадьба с панорамным видом, свадебная площадка на крыше, где провести свадьбу спб",
    date: "2026-05-01",
    category: "Свадьба",
    readTime: 8,
    image: "/photos/view_sunset.webp",
    lead: "Свадьба на крыше с видом на Петербург — формат, который за несколько лет из нишевого стал одним из самых востребованных. Панорама над городом, закат на горизонте, ощущение высоты — декорации, которые не нужно придумывать. «Паруса на крыше» проводят свадьбы на крыше с 2009 года.",
    sections: [
      {
        heading: "Почему крыша стала популярным свадебным форматом",
        body: "Традиционный зал с колоннами и хрусталём уступает место пространствам с характером. Крыша — это история: вид, высота, ощущение события. Фотографии на фоне панорамы города выглядят иначе, чем в банкетном зале. Для пары, которая хочет свадьбу, запоминающуюся не стандартным декором, а местом — крыша стала первым выбором.",
      },
      {
        heading: "Форматы свадьбы на крыше",
        body: "В зависимости от желаний пары и количества гостей «Паруса на крыше» предлагают несколько вариантов.",
        list: [
          "Камерная свадьба для двух (только роспись) — минималистичный формат",
          "Небольшой банкет до 30 человек — только близкие, в отдельном зале",
          "Полноценный свадебный банкет до 200 человек — зал + терраса",
          "Выездная регистрация на открытой террасе — под открытым небом",
        ],
      },
      {
        heading: "Выездная регистрация на крыше",
        body: "«Паруса на крыше» организуют выездную регистрацию брака на открытой террасе — с видом на исторический центр Петербурга. Для этого нужно заключить договор с ЗАГСом на выездную регистрацию. Ресторан предоставляет площадку, декор по договорённости, цветочное оформление — через партнёров или ваших подрядчиков.",
        highlight: "Выездная регистрация на крыше возможна с мая по сентябрь при хорошей погоде.",
      },
      {
        heading: "Меню и банкет",
        body: "Свадебное меню разрабатывается совместно с шефом под бюджет и пожелания. Есть несколько готовых банкетных пакетов — от 4 500 ₽ до 8 000 ₽ на персону в зависимости от состава блюд и включённых напитков. Все детали согласовываются на дегустации за 1–2 месяца до свадьбы.",
      },
      {
        heading: "Как начать планирование",
        body: "Для первого контакта и резервирования даты — звоните по +7 (812) 991-10-90 или оставьте заявку на сайте. Популярные даты (особенно июнь–август) занимают за 3–6 месяцев — бронируйте заблаговременно.",
      },
    ],
    cta: { text: "Забронировать свадьбу на крыше", href: "/svadba" },
  },
  {
    slug: "banket-na-kryshe-spb",
    title: "Банкет на крыше с панорамным видом в Петербурге",
    metaTitle: "Банкет на крыше СПб — до 300 гостей | Паруса на крыше",
    metaDescription: "Банкет на крыше в Петербурге с панорамным видом на город: залы до 300 гостей, авторское меню, профессиональная сцена и звук. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "банкет на крыше спб, банкет с видом на город, банкетный зал на крыше, провести банкет петербург",
    date: "2026-05-03",
    category: "Банкеты",
    readTime: 7,
    image: "/photos/view_summer.webp",
    lead: "Банкет на крыше в Петербурге — это событие, которое запоминается всем гостям. Панорамный вид на исторический центр, профессиональная сцена и звук, авторское меню — «Паруса на крыше» принимают банкеты на 20–300 человек с 2009 года.",
    sections: [
      {
        heading: "Площадки для банкета",
        body: "В зависимости от размера компании доступны разные форматы площадки.",
        list: [
          "Отдельный зал (до 50 человек) — полная приватность",
          "Основной зал (до 150 человек) — полная аренда",
          "Зал + открытая терраса (до 300 человек) — максимальная вместимость",
          "Только терраса (до 100 человек) — летний формат под открытым небом",
        ],
      },
      {
        heading: "Техническое оснащение",
        body: "«Паруса на крыше» оборудованы профессиональной звуковой и световой системой: сцена для выступлений и живой музыки, микрофоны, проектор, экран для видеопоздравлений. Это убирает необходимость арендовать оборудование у сторонних компаний — всё включено в площадку.",
        highlight: "Профессиональная сцена и звук включены в аренду зала — дополнительная оплата не требуется.",
      },
      {
        heading: "Банкетное меню",
        body: "Шеф-повар разрабатывает банкетное меню по индивидуальному согласованию. Есть готовые пакеты от 2 500 ₽ до 6 500 ₽ на персону (зависит от состава блюд и включённых напитков). Возможна дегустация до мероприятия. Алкогольная карта — обширная, с опцией «безалкогольного банкета».",
      },
      {
        heading: "Организация и дополнительные услуги",
        body: "Ресторан помогает с организацией: рекомендует ведущих, DJ и живые группы, фотографов и видеографов. Декор помещения согласовывается отдельно. Для банкета с выездной регистрацией или тематическим оформлением — контактируйте с менеджером.",
      },
      {
        heading: "Как забронировать",
        body: "Для банкета на 30+ человек звоните по +7 (812) 991-10-90 — менеджер уточнит детали и предложит подходящую площадку. Бронируйте за 1–3 месяца, особенно на летний сезон и пятницы/субботы.",
      },
    ],
    cta: { text: "Запросить расчёт банкета", href: "/banket" },
  },
  {
    slug: "arenda-restorana-na-kryshe",
    title: "Аренда ресторана на крыше для мероприятия в Петербурге",
    metaTitle: "Аренда ресторана на крыше СПб — полная аренда зала | Паруса на крыше",
    metaDescription: "Арендуйте ресторан на крыше в Петербурге целиком: зал до 300 человек, панорамный вид, профессиональная сцена и звук. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "аренда ресторана на крыше, арендовать ресторан целиком спб, ресторан на крыше под мероприятие",
    date: "2026-05-05",
    category: "Банкеты",
    readTime: 6,
    image: "/photos/view_summer.webp",
    lead: "Аренда ресторана на крыше целиком — формат для тех, кто хочет приватность и масштаб. До 300 гостей, профессиональная площадка с оборудованием, панорама на 300° над Петербургом. «Паруса на крыше» сдаются в аренду под свадьбы, корпоративы, презентации и закрытые вечеринки.",
    sections: [
      {
        heading: "Что входит в аренду ресторана",
        body: "При полной аренде «Паруса на крыше» вы получаете всю площадку исключительно для своего мероприятия.",
        list: [
          "Все залы + открытая терраса (при сезонной возможности)",
          "Профессиональная сцена, звук, свет и экран",
          "Панорамный вид на 300° на исторический центр",
          "Отдельный вход и приватное обслуживание",
          "Возможность украшения и изменения расстановки",
        ],
      },
      {
        heading: "Для каких мероприятий подходит",
        body: "«Паруса на крыше» в аренду принимают: свадьбы (до 300 человек), корпоративы и тимбилдинги, юбилеи и дни рождения, презентации продуктов, закрытые вечеринки и фуршеты, выпускные вечера и банкеты.",
      },
      {
        heading: "Цена аренды",
        body: "Стоимость аренды ресторана на крыше зависит от дня недели, сезона и количества гостей. Минимальный заказ еды и напитков, как правило, зачитывается в счёт аренды. Точный расчёт — при звонке по +7 (812) 991-10-90.",
        highlight: "Зимние и будние даты — выгоднее. Летние выходные — бронируются за 3–6 месяцев.",
      },
      {
        heading: "Как забронировать аренду",
        body: "Для резервирования даты и согласования деталей звоните по +7 (812) 991-10-90 или оставьте заявку на сайте. Менеджер свяжется, уточнит параметры мероприятия и подготовит коммерческое предложение.",
      },
    ],
    cta: { text: "Запросить аренду ресторана", href: "/banket" },
  },
  {
    slug: "svadebnyy-banket-spb",
    title: "Свадебный банкет с видом на Петербург: как организовать",
    metaTitle: "Свадебный банкет СПб с видом на город — Паруса на крыше",
    metaDescription: "Свадебный банкет в Петербурге с панорамным видом на город: меню, вместимость, сцена, терраса. «Паруса на крыше» — ваша свадьба на крыше. +7 (812) 991-10-90.",
    keywords: "свадебный банкет спб, свадебное меню с видом, свадебный банкет на крыше, банкет на свадьбу петербург",
    date: "2026-05-07",
    category: "Свадьба",
    readTime: 7,
    image: "/photos/view_sunset.webp",
    lead: "Свадебный банкет с видом на Петербург — это не просто ресторан для праздника. Это место, которое становится частью свадебной истории: панорама над городом, закат на горизонте, ощущение, что весь Петербург участвует в вашем дне.",
    sections: [
      {
        heading: "Как выбрать место для свадебного банкета",
        body: "Место для свадебного банкета определяет настроение всего дня. Главные критерии: вместимость, приватность, сервис, кухня и, конечно, атмосфера. Вид на город добавляет к этому ещё один измерение: ваши гости запомнят не только стол, но и пространство вокруг.",
        list: [
          "Вместимость: от 20 до 300 гостей в зависимости от формата",
          "Приватность: возможность полной аренды",
          "Терраса: открытая с видом на центр (май–сентябрь)",
          "Сцена и оборудование — включены",
        ],
      },
      {
        heading: "Свадебное меню",
        body: "Шеф-повар «Парусов» разрабатывает свадебное меню индивидуально под пару. Стандартная структура: приветственный фуршет, торжественный ужин (3–4 перемены), свадебный торт. Возможна дегустация меню за 6–8 недель до свадьбы. Средняя стоимость банкетного меню — от 5 000 ₽ на персону.",
        highlight: "Дегустация меню — бесплатно для пары при бронировании на 50+ человек.",
      },
      {
        heading: "Оформление и декор",
        body: "Ресторан работает с партнёрскими флористами и декораторами. Можно привести своих подрядчиков — никаких ограничений. Базовое оформление стола (приборы, скатерть, свечи) включено. Тематический декор, живые цветы, фотозона — по отдельному согласованию.",
      },
      {
        heading: "Как начать подготовку",
        body: "Звоните по +7 (812) 991-10-90 или оставьте заявку на сайте. Популярные летние даты занимают за 4–6 месяцев. На первой встрече с менеджером обсуждаются дата, количество гостей, формат, меню и бюджет.",
      },
    ],
    cta: { text: "Запланировать свадьбу на крыше", href: "/svadba" },
  },
  {
    slug: "kamernaya-svadba-spb",
    title: "Камерная свадьба на крыше в Петербурге",
    metaTitle: "Камерная свадьба на крыше СПб — маленькая свадьба | Паруса на крыше",
    metaDescription: "Камерная свадьба на крыше в Петербурге для 2–30 гостей: выездная регистрация, ужин с видом, атмосфера без суеты. «Паруса на крыше» — +7 (812) 991-10-90.",
    keywords: "камерная свадьба спб, маленькая свадьба на крыше, свадьба для двоих петербург, мини свадьба с видом",
    date: "2026-05-09",
    category: "Свадьба",
    readTime: 6,
    image: "/photos/view_sunset.webp",
    lead: "Камерная свадьба — это сознательный выбор: только самые близкие, без лишней помпы, но с по-настоящему особым местом. Крыша с панорамным видом на Петербург создаёт атмосферу, которую не воссоздать ни в каком банкетном зале.",
    sections: [
      {
        heading: "Что такое камерная свадьба и кому она подходит",
        body: "Камерная свадьба — формат до 30–40 гостей. Она популярна у пар, которые ценят атмосферу важнее количества, хотят провести день в непринуждённой обстановке без официального протокола и избегают многочасовой программы с тостами и конкурсами. На крыше это работает особенно хорошо: вид сам по себе создаёт торжественность без лишней декорации.",
      },
      {
        heading: "Форматы камерной свадьбы",
        body: "«Паруса на крыше» предлагают несколько сценариев для небольшой свадьбы.",
        list: [
          "Роспись + ужин для двоих — только пара и свидетели",
          "Семейный ужин — 10–20 человек, отдельный зал",
          "Выездная регистрация + банкет на 30 человек — терраса + зал",
          "Только выездная регистрация — без банкета",
        ],
      },
      {
        heading: "Преимущества камерного формата",
        body: "В маленькой свадьбе пара проводит время с каждым гостем — а не бегает по залу с 200 людьми. Бюджет при этом ниже, организационной нагрузки меньше, а впечатления — не меньше. Вид на Петербург с крыши одинаково работает для двух и для двадцати человек.",
        highlight: "Камерная свадьба на крыше обходится дешевле больших форматов, но производит не меньше впечатления.",
      },
      {
        heading: "Планирование",
        body: "Для согласования камерной свадьбы звоните по +7 (812) 991-10-90 — менеджер расскажет о доступных форматах, помещениях и стоимости. Для небольших свадеб планирование занимает 1–2 месяца.",
      },
    ],
    cta: { text: "Организовать камерную свадьбу", href: "/svadba" },
  },
  {
    slug: "vyezdnaya-registraciya-spb",
    title: "Выездная регистрация на крыше в Петербурге",
    metaTitle: "Выездная регистрация на крыше СПб — Паруса на крыше | 2026",
    metaDescription: "Выездная регистрация брака на крыше в Петербурге с панорамным видом на город. Организуем площадку, цветы и атмосферу. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "выездная регистрация спб, регистрация брака на крыше, выездная церемония петербург, роспись с видом на город",
    date: "2026-05-11",
    category: "Свадьба",
    readTime: 6,
    image: "/photos/terrace.webp",
    lead: "Выездная регистрация на крыше с видом на Петербург — один из самых красивых форматов росписи. Открытая терраса, панорама исторического центра и небо над головой заменяют любой декор. «Паруса на крыше» принимают выездные регистрации с полным сопровождением.",
    sections: [
      {
        heading: "Что такое выездная регистрация",
        body: "Выездная регистрация — официальная роспись в браке, которую сотрудник ЗАГС проводит вне ЗАГСа, в выбранном вами месте. Для этого нужно заключить договор с ЗАГС и оплатить услугу выездной регистрации. «Паруса на крыше» предоставляют площадку и организацию — от установки арки до цветочного оформления.",
        highlight: "Выездная регистрация требует предварительного согласования с ЗАГС — начинайте планирование за 3–4 месяца.",
      },
      {
        heading: "Площадка для церемонии",
        body: "Открытая терраса «Паруса на крыше» — идеальная площадка для выездной регистрации с мая по сентябрь. Вид на исторический центр Петербурга создаёт атмосферу без дополнительного декора. Для зимней церемонии — панорамный зал с видом через окно.",
      },
      {
        heading: "Что организует ресторан",
        body: "По согласованию ресторан обеспечивает: арку или флористическое оформление (через партнёров), живую музыку для церемонии, шампанское для гостей, фотозону на фоне панорамы. После церемонии — банкет или камерный ужин.",
        list: [
          "Цветочная арка для церемонии",
          "Живая музыка (скрипка, саксофон, квартет)",
          "Шампанское для гостей",
          "Переход в банкетный зал после церемонии",
        ],
      },
      {
        heading: "Стоимость и бронирование",
        body: "Стоимость площадки для выездной регистрации согласовывается отдельно и зависит от даты, дня недели и состава банкета. Звоните по +7 (812) 991-10-90 для расчёта.",
      },
    ],
    cta: { text: "Организовать выездную регистрацию", href: "/svadba" },
  },

  // ─── ВОЛНА 5 (май 2026) ──────────────────────────────────────────────────────
  {
    slug: "den-rozhdeniya-na-kryshe-spb",
    title: "День рождения на крыше в Петербурге: идеи и форматы",
    metaTitle: "День рождения на крыше СПб — с панорамой | Паруса на крыше",
    metaDescription: "День рождения на крыше в Петербурге: скидка 20% для именинника, банкет до 300 человек, вид на город. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "день рождения на крыше спб, др с панорамным видом, праздник на крыше петербург, день рождения с видом на город",
    date: "2026-05-13",
    category: "Особые поводы",
    readTime: 7,
    image: "/photos/view_sunset.webp",
    lead: "День рождения на крыше — это праздник, который гости вспоминают годами. Не потому что была самая дорогая программа, а потому что место создало то самое настроение. «Паруса на крыше» знают, как устроить ваш день рождения с видом на весь Петербург.",
    sections: [
      {
        heading: "Почему день рождения на крыше запоминается",
        body: "Место задаёт тон всему вечеру раньше, чем подадут первое блюдо. Панорама над городом, ощущение высоты, закат за окном — это не просто фон, это участник праздника. Гости, которые первый раз видят вид с 6-го этажа Olympic Plaza, неизбежно останавливаются и просто смотрят несколько секунд. Именно это и запоминается.",
      },
      {
        heading: "Форматы дня рождения",
        body: "В «Паруса на крыше» возможны разные форматы:",
        list: [
          "Камерный ужин на 2–10 человек — столик у панорамного окна",
          "Праздник с друзьями 15–50 человек — отдельный зал",
          "Большая вечеринка 50–300 человек — полная аренда с живой музыкой",
          "Корпоратив на день рождения компании — с программой и сценой",
        ],
      },
      {
        heading: "Скидка 20% для именинника",
        body: "Именинник получает скидку 20% на весь свой счёт — в течение 7 дней до и 7 дней после дня рождения. Скидка применяется при оплате наличными. Чтобы воспользоваться акцией, обязательно сообщите о поводе при бронировании.",
        highlight: "Скидка 20% действует 7 дней до и 7 дней после дня рождения. Оплата наличными. Бронируйте заранее.",
      },
      {
        heading: "Что можно организовать",
        body: "По запросу ресторан помогает с: украшением стола (шары, гирлянды, лепестки), тортом от шефа с надписью, живой музыкой или DJ, ведущим праздника. Для больших мероприятий — профессиональная сцена и звуковое оборудование включены.",
      },
      {
        heading: "Как забронировать",
        body: "Звоните по +7 (812) 991-10-90 или бронируйте онлайн на сайте. Для дня рождения больше 15 человек — рекомендуем звонить, чтобы согласовать детали по телефону.",
      },
    ],
    cta: { text: "Забронировать день рождения на крыше", href: "/den-rozhdeniya" },
  },
  {
    slug: "novogodniy-korporativ-spb",
    title: "Новогодний корпоратив в Петербурге с панорамным видом",
    metaTitle: "Новогодний корпоратив СПб 2026 с видом — Паруса на крыше",
    metaDescription: "Новогодний корпоратив в Петербурге на крыше: зал до 300 человек, живая музыка, панорамный вид на ночной город. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "новогодний корпоратив спб, новый год на крыше, корпоратив на новый год петербург, встреча нового года с видом",
    date: "2026-05-15",
    category: "Корпоративы",
    readTime: 6,
    image: "/photos/view_night.webp",
    lead: "Новогодний корпоратив с видом на ночной Петербург — формат, которым трудно удивить ещё раз так же. Поднявшись на крышу в ночь праздника, команда видит город совсем иначе: подсветка куполов, снег на крышах, ощущение особого момента. «Паруса на крыше» проводят новогодние корпоративы с 2009 года.",
    sections: [
      {
        heading: "Почему корпоратив на Новый год стоит делать на крыше",
        body: "Новогодний корпоратив — ежегодное мероприятие, и каждый год его хочется сделать лучше. Смена формата на «крышу» даёт мощный эффект: вид на ночной зимний Петербург с высоты, снег на крышах исторического центра, подсветка города — это то, что команда обсуждает в феврале.",
      },
      {
        heading: "Возможности площадки",
        body: "«Паруса на крыше» вмещают до 300 человек, оборудованы профессиональной сценой, звуком и светом. Для новогоднего корпоратива возможна тематическая декорация (по договорённости), живая музыка или DJ, ведущий. Зимой терраса не работает, но основной зал с панорамными окнами даёт полный вид на ночной город.",
        highlight: "Новогодние даты (декабрь) разбирают уже с сентября — бронируйте заранее.",
      },
      {
        heading: "Программа новогоднего вечера",
        body: "Стандартная структура новогоднего корпоратива: приветственный фуршет (19:00), торжественный ужин с программой (20:00–23:30), встреча Нового года (00:00), продолжение праздника. Программу ведущего согласовывают отдельно. Ресторан предоставляет контакты проверенных ведущих и групп.",
      },
      {
        heading: "Бюджет и бронирование",
        body: "Стоимость новогоднего корпоратива зависит от количества гостей, меню и программы. Минимальный расчёт — при звонке по +7 (812) 991-10-90. Бронируйте не позже октября — хорошие даты уходят быстро.",
      },
    ],
    cta: { text: "Забронировать новогодний корпоратив", href: "/korporativ" },
  },
  {
    slug: "yubiley-na-kryshe-spb",
    title: "Юбилей на крыше в Петербурге: как организовать праздник",
    metaTitle: "Юбилей на крыше СПб — с панорамой | Паруса на крыше",
    metaDescription: "Юбилей на крыше в Петербурге с видом на город: банкет до 300 гостей, живая музыка, авторская кухня. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "юбилей на крыше спб, где отметить юбилей спб, юбилей с панорамным видом, праздник юбилея петербург",
    date: "2026-05-17",
    category: "Особые поводы",
    readTime: 6,
    image: "/photos/view_summer.webp",
    lead: "Юбилей — особый праздник, который требует особого места. Крыша с панорамным видом на Петербург добавляет масштаб событию: гости чувствуют торжественность не только от программы, но и от пространства вокруг.",
    sections: [
      {
        heading: "Почему юбилей лучше праздновать на крыше",
        body: "Юбилей — это не просто день рождения. Это событие с историей, которое отмечают люди, важные для именинника. Такое событие требует места с характером: не типовой банкетный зал, а пространство, которое само по себе говорит о значимости момента. Панорама Петербурга с высоты — именно такой аргумент.",
      },
      {
        heading: "Форматы юбилея в «Паруса на крыше»",
        body: "В зависимости от пожеланий именинника:",
        list: [
          "Камерный ужин для семьи и близких (10–30 человек)",
          "Торжественный банкет с программой (50–200 человек)",
          "Большой вечер с живой музыкой и сценой (до 300 человек)",
          "Только ужин без программы — для тихого, атмосферного праздника",
        ],
      },
      {
        heading: "Что организует ресторан",
        body: "По запросу «Паруса на крыше» помогают с: тортом от шефа с индивидуальным оформлением, живой музыкой (фортепиано, скрипка, вокал, джаз-трио), ведущим торжества, фото- и видеографами. Декор — через партнёров или ваших подрядчиков.",
        highlight: "Банкетное меню для юбилея разрабатывается индивидуально на дегустации с шефом.",
      },
      {
        heading: "Планирование и бронирование",
        body: "Для согласования даты и деталей звоните по +7 (812) 991-10-90. Для юбилея от 50 человек рекомендуем бронировать за 2–3 месяца. Менеджер подготовит коммерческое предложение под ваш бюджет.",
      },
    ],
    cta: { text: "Организовать юбилей на крыше", href: "/banket" },
  },
  {
    slug: "devichnik-spb",
    title: "Девичник на крыше в Петербурге: идеи и организация",
    metaTitle: "Девичник на крыше СПб — незабываемый вечер | Паруса на крыше",
    metaDescription: "Девичник на крыше в Петербурге: ужин с видом на город, фотозона, живая музыка. «Паруса на крыше» — лучшее место для девичника. +7 (812) 991-10-90.",
    keywords: "девичник спб, девичник на крыше, организовать девичник петербург, девичник с видом на город",
    date: "2026-05-19",
    category: "Особые поводы",
    readTime: 6,
    image: "/photos/view_sunset.webp",
    lead: "Девичник на крыше с видом на Петербург — это вечер, который получится на фотографиях лучше, чем в любом фотостудии, и запомнится всей компании. «Паруса на крыше» организуют девичник под ваши пожелания: от камерного ужина до вечеринки с DJ.",
    sections: [
      {
        heading: "Почему крыша — лучшее место для девичника",
        body: "Девичник — это вечер с «вау»-эффектом. Место должно работать на атмосферу само по себе: красиво, нетривиально, с хорошими фотографиями. Крыша с панорамой на Петербург создаёт именно это: вид, который не надо декорировать — он уже готов.",
      },
      {
        heading: "Что можно организовать",
        body: "«Паруса на крыше» для девичника предлагают:",
        list: [
          "Отдельный стол или зал только для вашей компании",
          "Фотозону на фоне панорамы города",
          "Живую музыку или DJ по запросу",
          "Коктейльное приветствие от бармена",
          "Торт или десертный стол с оформлением",
        ],
      },
      {
        heading: "Лучшее время для девичника",
        body: "Летний девичник в белые ночи — особое впечатление: вечер на террасе, закат над городом, сумерки, которые не заканчиваются. Зимний девичник в уютном зале с видом на ночной Петербург — другое, но не менее красивое.",
        highlight: "В белые ночи закатные столики разбирают за 5–7 дней — бронируйте заранее.",
      },
      {
        heading: "Бронирование",
        body: "Для организации девичника звоните по +7 (812) 991-10-90 или пишите в мессенджер. Менеджер согласует детали: дату, количество человек, формат и пожелания по декору и программе.",
      },
    ],
    cta: { text: "Организовать девичник на крыше", href: "/den-rozhdeniya" },
  },

  // ─── ВОЛНА 6 (июнь 2026) ─────────────────────────────────────────────────────
  {
    slug: "nagrady-parusa-na-kryshe",
    title: "Награды ресторана «Паруса на крыше»: достижения и признание",
    metaTitle: "Награды «Паруса на крыше» — лучший ресторан СПб | 2026",
    metaDescription: "Награды и достижения ресторана «Паруса на крыше» в Петербурге: Time Out, Яндекс Хорошее место, рейтинг 5,0. Узнайте, почему нас выбирают снова. +7 (812) 991-10-90.",
    keywords: "награды паруса на крыше, премии ресторана спб, достижения паруса на крыше, лучший ресторан петербург премия",
    date: "2026-06-01",
    category: "О ресторане",
    readTime: 5,
    image: "/photos/interior.webp",
    lead: "«Паруса на крыше» работают с 2009 года и за эти годы собрали ряд профессиональных и пользовательских признаний. Вот что говорят о ресторане медиа, гиды и сами гости.",
    sections: [
      {
        heading: "Профессиональные признания",
        body: "Time Out Санкт-Петербург включил «Паруса на крыше» в список лучших ресторанов с видом на город. The Village упомянул ресторан в гиде по лучшим местам Петербурга. Яндекс присвоил статус «Хорошее место 2026» — это автоматическое признание, которое получают только заведения с высоким и стабильным рейтингом.",
        list: [
          "Time Out СПб — Лучший ресторан с видом на город",
          "The Village — Гид по Петербургу",
          "Яндекс — Хорошее место 2026",
          "2ГИС — ТОП ресторанов СПб",
        ],
      },
      {
        heading: "Рейтинги гостей",
        body: "Рейтинг 5,0 на Яндекс Картах при 2 606 отзывах — исключительный результат, который трудно поддерживать годами. Рейтинг 4,9 на 2ГИС при более 800 отзывах подтверждает стабильность качества. Это не разовая акция, а многолетняя репутация.",
        highlight: "5,0 / 5,0 на Яндекс Картах — 2 606 отзывов. Один из высших рейтингов среди ресторанов Петербурга.",
      },
      {
        heading: "Что говорят гости",
        body: "В отзывах гости чаще всего выделяют три вещи: вид (особенно закат и белые ночи), живую музыку и уровень сервиса. Кухня занимает отдельное место — особенно фирменные блюда из локальных продуктов. Многие гости отмечают, что возвращаются именно сюда на годовщины, дни рождения и особые поводы.",
      },
    ],
    cta: { text: "Убедиться самим — забронировать столик", href: "/" },
  },
  {
    slug: "parusa-na-kryshe-spb",
    title: "Ресторан «Паруса на крыше» в Петербурге: полный гид",
    metaTitle: "Паруса на крыше — ресторан СПб: адрес, меню, цены | 2026",
    metaDescription: "«Паруса на крыше» — панорамный ресторан в центре Петербурга: адрес, часы работы, меню, цены, как добраться. Ул. Марата 5, 6 этаж. +7 (812) 991-10-90.",
    keywords: "паруса на крыше спб, ресторан паруса на крыше, паруса на крыше адрес, паруса на крыше меню",
    date: "2026-06-03",
    category: "О ресторане",
    readTime: 7,
    image: "/photos/view_day.webp",
    lead: "«Паруса на крыше» — панорамный ресторан в историческом центре Санкт-Петербурга, работающий с 2009 года. Расположен на 6-м этаже бизнес-центра Olympic Plaza по адресу ул. Марата, 5. Панорама 300° на центр города, открытая летняя терраса, авторская кухня, банкетные залы до 300 гостей.",
    sections: [
      {
        heading: "Адрес и как добраться",
        body: "«Паруса на крыше»: ул. Марата, 5, 6 этаж, Olympic Plaza. Это в 5 минутах пешком от станции метро «Владимирская» и в 10 минутах от «Маяковской». Улица Марата — тихая улица в самом сердце Центрального района, без туристической суеты Невского.",
        list: [
          "Ул. Марата, 5, 6 этаж (Olympic Plaza)",
          "5 мин пешком от м. Владимирская",
          "10 мин от м. Маяковская",
          "Парковка рядом с домом",
        ],
      },
      {
        heading: "Часы работы",
        body: "Ресторан работает ежедневно: понедельник–четверг и воскресенье с 12:00 до 23:00, пятница и суббота — с 12:00 до 01:00 следующего дня. Бизнес-ланч — понедельник–пятница с 12:00 до 16:00 от 590 ₽. Открытая терраса — с мая по сентябрь при хорошей погоде.",
        highlight: "Звоните для бронирования: +7 (812) 991-10-90. Бронирование онлайн — на сайте.",
      },
      {
        heading: "Меню и кухня",
        body: "Авторская кухня на основе локальных продуктов Северо-Запада России: балтийская рыба, карельские грибы, новгородские ягоды. Шеф меняет меню сезонно. Отдельный бизнес-ланч, банкетные меню, детское меню. Средний чек — от 2 500 ₽.",
      },
      {
        heading: "Форматы посещения",
        body: "«Паруса на крыше» подходят для: романтического ужина для двоих, ужина с компанией, делового обеда, банкета (20–300 человек), свадьбы, корпоратива, дня рождения, юбилея.",
      },
      {
        heading: "Рейтинг и отзывы",
        body: "Рейтинг 5,0 на Яндекс Картах (2 606 отзывов), 4,9 на 2ГИС (800+ отзывов). Яндекс — «Хорошее место 2026». Лучший ресторан с видом по версии Time Out.",
      },
    ],
    cta: { text: "Забронировать столик", href: "/" },
  },
  {
    slug: "parusa-na-kryshe-otzyvy",
    title: "Почему «Паруса на крыше» — выбор тысяч гостей Петербурга",
    metaTitle: "«Паруса на крыше» отзывы — почему выбирают | СПб 2026",
    metaDescription: "Почему «Паруса на крыше» получают 5,0 на Яндекс Картах: реальные отзывы, причины популярности, что особенного в этом ресторане. +7 (812) 991-10-90.",
    keywords: "паруса на крыше отзывы, отзывы о панорамном ресторане, паруса на крыше рейтинг, почему выбирают паруса",
    date: "2026-06-05",
    category: "О ресторане",
    readTime: 6,
    image: "/photos/view_summer.webp",
    lead: "«Паруса на крыше» — ресторан с рейтингом 5,0 на Яндекс Картах при 2 606 отзывах. Такой результат не получить случайно — за ним стоит многолетняя репутация. Разбираем, за что гости ставят высшие оценки и возвращаются снова.",
    sections: [
      {
        heading: "Что чаще всего отмечают в отзывах",
        body: "Анализ отзывов показывает несколько устойчивых тем, которые появляются в большинстве оценок.",
        list: [
          "Вид: «самый красивый вид на Петербург» — упоминается в 80% пятизвёздочных отзывов",
          "Сервис: «внимательный и ненавязчивый» — ключевое слово многих отзывов",
          "Живая музыка: «атмосфера совершенно особая»",
          "Еда: «кухня не уступает виду»",
          "Повод: «возвращаемся на каждый особый случай»",
        ],
      },
      {
        heading: "Почему возвращаются снова",
        body: "Постоянные гости «Парусов» — люди, которые открыли ресторан на какой-то особый повод и с тех пор возвращаются сюда снова. День рождения → годовщина → свидание → юбилей. Ресторан становится «своим местом» — что для заведения является высшей оценкой.",
        highlight: "Более 30% гостей «Паруса на крыше» возвращаются повторно в течение года.",
      },
      {
        heading: "Честно о минусах",
        body: "Ни один ресторан не идеален. Гости иногда отмечают: ожидание в пик сезона, цены выше средних по городу, зависимость от погоды на террасе. Но при рейтинге 5,0 эти аспекты явно не перевешивают достоинства.",
      },
      {
        heading: "Итог: для кого этот ресторан",
        body: "«Паруса на крыше» — ресторан для тех, кто ищет не просто поесть, а провести время в месте с настроением. Для особых поводов, романтических вечеров, встреч с близкими людьми и событий, которые должны запомниться.",
      },
    ],
    cta: { text: "Убедиться лично — забронировать столик", href: "/" },
  },
  {
    slug: "shef-povar-parusa-na-kryshe",
    title: "Авторская кухня «Паруса на крыше»: что готовит шеф",
    metaTitle: "Шеф и кухня «Паруса на крыше» СПб — авторское меню | 2026",
    metaDescription: "Авторская кухня ресторана «Паруса на крыше»: локальные продукты Северо-Запада, сезонное меню, фирменные блюда. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "шеф повар паруса на крыше, авторская кухня спб, шеф панорамного ресторана, фирменные блюда паруса",
    date: "2026-06-07",
    category: "О ресторане",
    readTime: 6,
    image: "/photos/food.webp",
    lead: "Авторская кухня «Паруса на крыше» — не просто дополнение к виду. Шеф-повар ресторана работает с локальными продуктами Северо-Запада России: балтийской рыбой, карельскими грибами, северными ягодами. Меню меняется сезонно — следуя продуктовому календарю региона.",
    sections: [
      {
        heading: "Концепция кухни",
        body: "Кухня «Парусов» строится на принципе: лучшие продукты региона в авторской интерпретации. Шеф использует сезонные поставки: летом — ягоды, дикоросы и свежая рыба; зимой — заготовки, корнеплоды и выдержанные сыры. Это означает, что меню в июне отличается от меню в ноябре — и это принципиально важно для качества.",
      },
      {
        heading: "Фирменные блюда",
        body: "Несколько позиций меню остаются постоянными и считаются визитной карточкой ресторана.",
        list: [
          "Уха из лосося с гребешком — фирменная подача с видом",
          "Тартар из говядины с трюфельным маслом",
          "Ризотто с белыми грибами и пармезаном",
          "Торт «Птичье молоко» в авторском исполнении",
          "Сезонный десерт с северными ягодами",
        ],
      },
      {
        heading: "Меню для особых случаев",
        body: "Для банкетов, свадеб и корпоративов шеф разрабатывает индивидуальное меню. Возможна дегустация до мероприятия. Банкетные сеты — от 2 500 до 6 500 ₽ на персону в зависимости от состава. Детское меню — по запросу.",
        highlight: "Бизнес-ланч: полный обед от 590 ₽ в будние дни с 12:00 до 16:00.",
      },
      {
        heading: "Кухня и вид: почему баланс важен",
        body: "Хороший вид прощает слабую кухню — но только один раз. Гости, которые возвращаются в «Паруса на крыше» снова и снова, отмечают, что кухня удерживает их не меньше, чем вид. Именно этот баланс — редкость для панорамных ресторанов.",
      },
    ],
    cta: { text: "Попробовать авторское меню", href: "/menu" },
  },
  {
    slug: "top-restoranov-na-kryshe-spb",
    title: "ТОП ресторанов на крыше в Петербурге 2026: подборка",
    metaTitle: "Топ ресторанов на крыше СПб 2026 — рейтинг и подборка | Паруса",
    metaDescription: "Лучшие рестораны на крышах Санкт-Петербурга в 2026 году: обзор, сравнение, выбор. «Паруса на крыше» — лидер рейтинга по отзывам гостей. +7 (812) 991-10-90.",
    keywords: "топ ресторанов на крыше спб, лучшие рестораны на крышах, подборка панорамных ресторанов, рейтинг 2026",
    date: "2026-06-09",
    category: "Ресторан",
    readTime: 7,
    image: "/photos/view_clouds.webp",
    lead: "В Петербурге несколько заведений претендуют на звание «ресторан на крыше», но далеко не все одинаково хороши. Разбираем, что действительно предлагает каждый формат и почему выбор сужается, когда смотришь на реальные данные.",
    sections: [
      {
        heading: "Критерии оценки",
        body: "Что нужно проверить перед выбором ресторана на крыше:",
        list: [
          "Реальная высота и открытая панорама (не вид во двор)",
          "Наличие открытой террасы в тёплый сезон",
          "Качество кухни — подтверждённое отзывами, а не маркетингом",
          "Рейтинг на Яндекс Картах и 2ГИС",
          "Возможность банкета и бронирования",
        ],
      },
      {
        heading: "«Паруса на крыше» — почему лидер",
        body: "По совокупности критериев «Паруса на крыше» устойчиво занимают верхнюю строчку среди панорамных ресторанов Петербурга. Рейтинг 5,0 при 2 606 отзывах на Яндексе — редкий результат для заведения с 15-летней историей. Открытая терраса, авторская кухня и залы до 300 человек для банкетов.",
        highlight: "Рейтинг 5,0 / 2 606 отзывов на Яндекс Картах — один из высших среди ресторанов СПб.",
      },
      {
        heading: "На что обратить внимание в других местах",
        body: "При выборе любого «панорамного» заведения проверяйте: реальные фотографии вида из зала (не с фасада), рейтинг выше 4,5 с большим количеством отзывов, наличие открытой террасы в тёплый сезон, возможность бронирования конкретного столика с видом.",
      },
      {
        heading: "Итог: как выбрать лучший ресторан на крыше",
        body: "Проверьте рейтинг на Яндекс Картах (не ниже 4,5), посмотрите реальные фотографии вида, уточните наличие открытой террасы и возможность бронирования. «Паруса на крыше» отвечают всем критериям — убедитесь сами.",
      },
    ],
    cta: { text: "Забронировать в лучшем ресторане на крыше", href: "/" },
  },
  {
    slug: "kak-dobratsya-restoran-spb",
    title: "Как добраться до «Паруса на крыше» в центре Петербурга",
    metaTitle: "Как добраться до Паруса на крыше — адрес и маршрут | СПб",
    metaDescription: "Как добраться до ресторана «Паруса на крыше»: адрес ул. Марата 5, метро, парковка, схема проезда. +7 (812) 991-10-90.",
    keywords: "как добраться ресторан спб, ресторан в центре петербурга, как подняться на крышу, маршрут до ресторана",
    date: "2026-06-11",
    category: "О ресторане",
    readTime: 5,
    image: "/photos/interior.webp",
    lead: "«Паруса на крыше» расположены в историческом центре Санкт-Петербурга по адресу ул. Марата, 5, 6 этаж Olympic Plaza. Добраться удобно пешком от двух станций метро, на такси или на собственном автомобиле.",
    sections: [
      {
        heading: "Адрес и как найти",
        body: "Адрес: ул. Марата, 5, 6 этаж (бизнес-центр Olympic Plaza). Это тихая улица параллельно Невскому проспекту, между Загородным проспектом и ул. Дмитровской. Вход в бизнес-центр с улицы Марата. Лифт на 6-й этаж. Вывеска «Паруса на крыше» видна от лифта.",
        highlight: "Если не можете найти вход — звоните: +7 (812) 991-10-90, вас встретят.",
      },
      {
        heading: "На метро",
        body: "Ближайшие станции метро:",
        list: [
          "Владимирская (линия 3) — 5 минут пешком",
          "Достоевская (линия 3) — 7 минут пешком",
          "Маяковская (линия 3) — 10 минут пешком",
        ],
      },
      {
        heading: "На такси и автомобиле",
        body: "Адрес для навигатора: Санкт-Петербург, ул. Марата, 5. Платная парковка — рядом с домом и на улице Марата. В будние дни парковка свободнее, в выходные — рекомендуем приехать заранее или воспользоваться такси.",
      },
      {
        heading: "Пешком от Невского",
        body: "От Невского проспекта до ул. Марата — 3–5 минут пешком через Стремянную улицу или через Ломоносовскую. Ориентир: Universal — торговый дом на Невском. Или — любой навигатор по адресу «ул. Марата, 5, Санкт-Петербург».",
      },
    ],
    cta: { text: "Забронировать и приехать", href: "/contacts" },
  },
  {
    slug: "panorama-peterburga",
    title: "Что посмотреть с высоты в Петербурге: панорама города",
    metaTitle: "Панорама Петербурга с высоты — что видно | Паруса на крыше",
    metaDescription: "Панорама Петербурга с высоты: что видно с крыши ресторана «Паруса на крыше», лучшие обзорные точки, как увидеть город с высоты. +7 (812) 991-10-90.",
    keywords: "панорама петербурга, что посмотреть с высоты спб, виды петербурга сверху, обзор города с крыши",
    date: "2026-06-13",
    category: "Виды и атмосфера",
    readTime: 7,
    image: "/photos/view_clouds.webp",
    lead: "Петербург с высоты выглядит совсем иначе, чем с уровня улицы: открывается горизонт, видны купола и силуэты, которые с земли перекрыты домами. С крыши «Паруса на крыше» на 6-м этаже открывается панорама 300° на исторический центр — вот что именно видно.",
    sections: [
      {
        heading: "Что открывается с 6-го этажа",
        body: "С панорамных окон и открытой террасы «Парусов» виден исторический центр Петербурга:",
        list: [
          "Силуэт Исаакиевского собора — главный ориентир панорамы",
          "Купола Троицкой и Казанской церквей",
          "Крыши Центрального района — бесконечная черепица",
          "В ясную погоду — Финский залив на горизонте",
          "Смольный собор — на востоке, над городом",
        ],
      },
      {
        heading: "Лучшее время для панорамы",
        body: "Каждое время суток и года даёт разную панораму. Летом закат превращает небо в оранжево-розовую палитру — идеально для фотографий. Зимой — снег на черепичных крышах и голубоватый дневной свет. Белые ночи — сумерки, которые создают совершенно особое настроение. Ночью — подсветка куполов и мостов.",
        highlight: "Самая эффектная панорама — в «золотой час» за 40 минут до заката.",
      },
      {
        heading: "Чем отличается ресторанная панорама от смотровой",
        body: "На смотровой площадке вы проводите 15–30 минут, потом уходите. В ресторане с панорамой можно провести весь вечер: за едой и разговором наблюдать, как меняется свет — от дневного к закатному и к ночному. Это совсем другой опыт.",
      },
      {
        heading: "Фотографии с панорамы",
        body: "Лучшие фотографии с панорамы «Парусов» получаются: на открытой террасе (без бликов стекла), в «золотой час» заката, утром в ясную погоду — тогда виден весь горизонт. Профессиональный фотограф по запросу — рекомендуется для особых поводов.",
      },
    ],
    cta: { text: "Забронировать столик с панорамой", href: "/" },
  },
  {
    slug: "fotosessiya-na-kryshe-spb",
    title: "Фотосессия на крыше в Петербурге: лучшие места и советы",
    metaTitle: "Фотосессия на крыше СПб — лучшие локации 2026 | Паруса на крыше",
    metaDescription: "Фотосессия на крыше в Петербурге: панорамная терраса с видом на город, лучший свет — закат и белые ночи. «Паруса на крыше» — идеальная локация. +7 (812) 991-10-90.",
    keywords: "фотосессия на крыше спб, красивые места для фото спб, фотозона с видом на город, фото на закате петербург",
    date: "2026-06-15",
    category: "Виды и атмосфера",
    readTime: 6,
    image: "/photos/terrace.webp",
    lead: "Фотосессия на крыше в Петербурге с видом на исторический центр — один из самых востребованных форматов для портретных съёмок, лавстори, свадебных фото и контента для соцсетей. Открытая терраса «Паруса на крыше» — идеальная локация с настоящим видом.",
    sections: [
      {
        heading: "Почему крыша — лучшая фотолокация",
        body: "Во-первых, фон: крыши Петербурга на горизонте — это то, что невозможно воссоздать в студии. Во-вторых, свет: на высоте он чище и ровнее, особенно в закатные часы. В-третьих, воздух: фотографии на открытой террасе не имеют отражений от стекла и выглядят естественно.",
        list: [
          "Фон: крыши и купола центра Петербурга",
          "Свет: чистый закатный свет без теней",
          "Воздух: нет бликов и отражений от стекла",
          "Приватность: нет случайных прохожих в кадре",
        ],
      },
      {
        heading: "Лучшее время для фотосессии",
        body: "Закат — главное время для фотосессий на крыше: «золотой час» даёт тёплый свет, который делает любой кадр красивым. В Петербурге закат в сезон — после 21:00, что даёт много времени для вечерней съёмки. Белые ночи — уникальный петербургский свет, «синий час», который длится часами.",
        highlight: "«Синий час» белых ночей — 23:00–00:30 в июне — даёт особое мягкое освещение, уникальное для Петербурга.",
      },
      {
        heading: "Для каких фотосессий подходит терраса",
        body: "Открытая терраса «Парусов» подходит для: лавстори и свадебных фото, портретных съёмок, бьюти-фотосессий с городским фоном, контента для блогов и соцсетей, семейных фото на особый повод.",
      },
      {
        heading: "Как организовать фотосессию",
        body: "Для фотосессии на террасе бронируйте столик стандартно — как для ужина. Ресторан может рекомендовать профессионального фотографа. Для организации отдельного съёмочного слота — уточняйте по телефону +7 (812) 991-10-90.",
      },
    ],
    cta: { text: "Забронировать столик для фотосессии", href: "/terrasa" },
  },
  {
    slug: "sredniy-chek-restoran-spb",
    title: "Средний чек в ресторане «Паруса на крыше»: цены и форматы",
    metaTitle: "Средний чек «Паруса на крыше» СПб — цены 2026 | Меню",
    metaDescription: "Сколько стоит ужин в «Паруса на крыше»: средний чек, бизнес-ланч от 590 ₽, романтический ужин, банкет. Паруса на крыше — +7 (812) 991-10-90.",
    keywords: "средний чек ресторан спб, цены в панорамном ресторане, сколько стоит ужин спб, меню с ценами петербург",
    date: "2026-06-15",
    category: "О ресторане",
    readTime: 5,
    image: "/photos/food.webp",
    lead: "«Паруса на крыше» — ресторан с авторской кухней и панорамным видом, и это влияет на ценовой диапазон. Но для разных форматов посещения цены сильно различаются: от бизнес-ланча за 590 ₽ до банкетного меню для большой компании.",
    sections: [
      {
        heading: "Форматы и цены",
        body: "В зависимости от формата посещения средний чек отличается существенно.",
        list: [
          "Бизнес-ланч — от 590 ₽ (будни, 12:00–16:00)",
          "Лёгкий обед/ужин (закуска + блюдо) — от 1 500 ₽",
          "Полный ужин (закуска + горячее + десерт + напитки) — от 2 500–3 500 ₽",
          "Романтический ужин для двоих — от 6 000–8 000 ₽ суммарно",
          "Банкетное меню — от 2 500 ₽/чел. (без алкоголя)",
        ],
      },
      {
        heading: "Что включено в цену",
        body: "В стоимость блюд включено: приготовление, сервировка и, конечно, вид из окна. Алкоголь — отдельно по карте. Для романтических вечеров — украшение стола и сюрприз оговариваются отдельно и могут быть как бесплатными (для особых поводов), так и по отдельной стоимости.",
        highlight: "Бизнес-ланч (590 ₽) — лучший способ познакомиться с кухней ресторана за минимальный бюджет.",
      },
      {
        heading: "Сравнение с другими ресторанами Петербурга",
        body: "Для панорамного ресторана в историческом центре с авторской кухней средний чек «Парусов» конкурентен. Сопоставимые по качеству заведения на Невском и Петроградке нередко дороже при меньшем виде. Соотношение «вид + кухня + сервис / цена» — одно из лучших в своей категории.",
      },
      {
        heading: "Как сэкономить",
        body: "Для оптимального бюджета: бизнес-ланч в будни (590 ₽) — лучшая цена за качество. Скидка 20% для именинника — в течение 7 дней до и после дня рождения (оплата наличными). Бронирование заранее — иногда позволяет договориться о специальных условиях для группы.",
      },
    ],
    cta: { text: "Забронировать столик", href: "/" },
  },
  ...BLOG_RESTAURANTS_PART1,
  ...BLOG_RESTAURANTS_PART2,
  ...BLOG_EVENTS_PART1,
  ...BLOG_EVENTS_PART2,
  ...BLOG_CUISINE_PART1,
  ...BLOG_FAQ_PART1,
  ...BLOG_FAQ_PART2,
  ...BLOG_GUIDE_PART1,
  ...BLOG_GUIDE_PART2,
  ...BLOG_GUIDE_PART3,
  ...BLOG_LIFESTYLE_PART1,
  ...BLOG_LIFESTYLE_PART2,
  ...BLOG_RESTAURANTS_PART3,
  ...BLOG_RESTAURANTS_PART4,
  ...BLOG_EVENTS_PART3,
  ...BLOG_EVENTS_PART4,
  ...BLOG_CUISINE_PART2,
  ...BLOG_CUISINE_PART3,
  ...BLOG_BIRTHDAY_PART1,
  ...BLOG_BIRTHDAY_PART2,
  ...BLOG_BIRTHDAY_PART3,
  ...BLOG_BIRTHDAY_PART4,
  ...BLOG_BIRTHDAY_PART5,
];

export function getPost(slug: string): BlogPost | undefined {
  return BLOG_POSTS.find(p => p.slug === slug);
}
